(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-discount"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-cart-discount')) {
    customElements.define('kk-cart-discount', class extends HTMLElement {
      constructor() {
        super();
        this.applying = false;

        // Submit explicitly instead of applying once on blur and again on click.
        this.addEventListener('change', (event) => {
          if (event.target.matches('cart-discount-field input:not([type="hidden"])')) {
            event.stopPropagation();
          }
        }, true);

        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-discount-apply]')) {
            event.preventDefault();
            this.applyDiscount();
          }
        });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' && !event.isComposing && event.target.matches('cart-discount-field input:not([type="hidden"])')) {
            event.preventDefault();
            event.stopPropagation();
            this.applyDiscount();
          }
        });
      }

      async applyDiscount() {
        if (this.applying) return;

        const field = this.querySelector('cart-discount-field');
        const input = field.querySelector('input:not([type="hidden"])');
        const button = this.querySelector('[data-discount-apply]');
        const banner = this.querySelector('cart-discount-banner');
        const code = input.value.trim();

        if (!code) {
          input.focus();
          return;
        }

        this.applying = true;
        button.disabled = true;
        input.readOnly = true;
        banner.hidden = true;
        try {
          await customElements.whenDefined('cart-discount-field');
          input.value = code;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          await field.toggleDiscount({ currentTarget: field, target: { value: code } });
        } catch (error) {
          this.dispatchEvent(new CustomEvent('cart:discount:error', { bubbles: true }));
        } finally {
          this.applying = false;
          field.setAttribute('aria-busy', 'false');
          button.disabled = false;
          input.readOnly = false;
          if (this.isConnected && !banner.hidden) input.focus();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kk-aari-pheran-measurements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-aari-pheran-measurements')) {
    const sizingDrafts = new Map();
    const currentComponent = (key) => Array.from(document.querySelectorAll('kk-aari-pheran-measurements')).find((node) => node.dataset.instance === key);
    customElements.define('kk-aari-pheran-measurements', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.init(); });
      }
      disconnectedCallback() {
        this.events?.abort();
        this.locks?.forEach((disabled, node) => { if (node.isConnected) node.disabled = disabled; });
        this.hiddenControls?.forEach((node) => node.removeAttribute('data-kk-sizing-hidden'));
      }
      init() {
        this.events?.abort();
        this.events = new AbortController();
        this.locks = new Map();
        this.hiddenControls = [];
        this.toggle = this.querySelector('[data-measurement-toggle]');
        this.fields = this.querySelector('[data-measurement-fields]');
        this.requestInput = this.querySelector('[data-measurement-request]');
        this.specialInput = this.querySelector('[data-special-request]');
        this.specialDetails = this.querySelector('[data-special-details]');
        this.status = this.querySelector('[data-measurement-status]');
        this.form = document.getElementById(this.dataset.form);
        this.picker = Array.from(document.querySelectorAll('variant-picker')).find((node) => node.getAttribute('form-id') === this.dataset.form);
        if (!this.form || !this.picker || typeof this.picker.selectCombination !== 'function' || !this.customControl()) return;
        const selectedSize = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.checked);
        let draft = sizingDrafts.get(this.dataset.instance);
        if (!draft) {
          draft = { mode: selectedSize?.value === this.dataset.customId ? 'custom' : 'standard', lastStandard: selectedSize?.value === this.dataset.customId ? '' : selectedSize?.value, measurements: '', special: '', specialOpen: false, pending: false, error: false };
          sizingDrafts.set(this.dataset.instance, draft);
        }
        this.state = draft;
        this.requestInput.value = draft.measurements;
        this.specialInput.value = draft.special;
        this.specialDetails.open = draft.specialOpen;
        this.querySelector('[data-measurement-toggle-label]').hidden = false;
        const custom = this.customControl();
        this.hideControl(custom);
        Array.from(custom.labels || []).forEach((label) => this.hideControl(label));
        custom.closest('fieldset')?.querySelectorAll('.variant-picker__option-info span').forEach((span) => {
          if (span.textContent.trim() === this.dataset.customValue) this.hideControl(span);
        });
        this.toggle.addEventListener('change', () => this.onToggle(), { signal: this.events.signal });
        this.requestInput.addEventListener('input', () => { draft.measurements = this.requestInput.value; this.validateMeasurements(); }, { signal: this.events.signal });
        this.specialInput.addEventListener('input', () => { draft.special = this.specialInput.value; }, { signal: this.events.signal });
        this.specialDetails.addEventListener('toggle', () => { draft.specialOpen = this.specialDetails.open; }, { signal: this.events.signal });
        document.addEventListener('change', (event) => this.onOptionChange(event), { capture: true, signal: this.events.signal });
        this.form.addEventListener('submit', (event) => this.guardSubmit(event), { capture: true, signal: this.events.signal });
        this.querySelector('[data-measurement-reload]').addEventListener('click', () => window.location.reload(), { signal: this.events.signal });
        this.form.addEventListener('reset', () => queueMicrotask(() => {
          draft.measurements = ''; draft.special = ''; draft.specialOpen = false;
          const active = currentComponent(this.dataset.instance);
          if (active) { active.requestInput.value = ''; active.specialInput.value = ''; active.specialDetails.open = false; active.sync(); }
        }), { signal: this.events.signal });
        this.sync();
      }
      controls() {
        return Array.from(this.form?.elements || []).filter((node) => node.matches('input[data-option-position]'));
      }
      customControl() {
        return this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === this.dataset.customId);
      }
      hideControl(node) {
        node.setAttribute('data-kk-sizing-hidden', '');
        this.hiddenControls.push(node);
      }
      onToggle() {
        if (this.state.pending || this.state.error) { this.sync(); return; }
        if (this.toggle.checked) {
          const standard = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.checked && node.value !== this.dataset.customId);
          if (standard) this.state.lastStandard = standard.value;
          this.state.mode = 'custom';
          this.selectSize(this.dataset.customId);
        } else {
          const previous = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === this.state.lastStandard && !node.disabled);
          this.state.mode = previous ? 'standard' : 'choose';
          if (previous) this.selectSize(previous.value);
          else this.sync();
        }
      }
      onOptionChange(event) {
        const input = event.target;
        if (!input.matches?.('input[data-option-position]') || input.form !== this.form) return;
        event.stopImmediatePropagation();
        if (this.state.pending || this.state.error) return;
        if (input.dataset.optionPosition === this.dataset.sizePosition) {
          this.state.mode = input.value === this.dataset.customId ? 'custom' : 'standard';
          if (this.state.mode === 'standard') this.state.lastStandard = input.value;
        }
        this.selectCombination();
      }
      selectSize(value) {
        const input = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === value);
        if (!input) { this.state.error = true; this.sync(); return; }
        input.checked = true;
        this.selectCombination();
      }
      async selectCombination() {
        const state = this.state;
        const key = this.dataset.instance;
        const optionValues = this.controls().filter((node) => node.checked).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((node) => node.value);
        state.expectedOptions = optionValues.join(',');
        state.pending = true;
        state.error = false;
        this.sync();
        const timer = setTimeout(() => {
          state.error = true;
          currentComponent(key)?.sync();
        }, 15000);
        try {
          await this.picker.selectCombination({ optionValues, productChange: false });
        } catch (error) {
          state.error = true;
        } finally {
          clearTimeout(timer);
          state.pending = false;
          currentComponent(key)?.sync();
        }
      }
      validateMeasurements() {
        this.requestInput.setCustomValidity(this.state.mode === 'custom' && !this.requestInput.value.trim() ? this.dataset.requiredMessage : '');
      }
      selectionMatches() {
        const variant = this.picker.selectedVariant;
        const isCustom = variant?.options?.[Number(this.dataset.sizePosition) - 1] === this.dataset.customValue;
        const variantInput = this.form.elements.namedItem('id');
        const renderedOptions = this.dataset.selectedOptions.split(',').filter(Boolean).join(',');
        const checkedOptions = this.controls().filter((node) => node.checked).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((node) => node.value).join(',');
        const expectedOptions = this.state.expectedOptions || renderedOptions;
        return Boolean(variant?.id && String(variant.id) === variantInput?.value && renderedOptions === expectedOptions && checkedOptions === expectedOptions && (this.state.mode === 'custom' ? isCustom : this.state.mode === 'standard' && !isCustom));
      }
      guardSubmit(event) {
        const blocked = this.state.pending || this.state.error || !this.selectionMatches();
        this.validateMeasurements();
        if (blocked || !this.requestInput.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.sync();
          if (!blocked) this.requestInput.reportValidity();
          else this.status.scrollIntoView({ block: 'nearest' });
        }
      }
      sync() {
        if (!this.state || !this.isConnected) return;
        if (!this.state.pending && this.state.mode !== 'choose' && !this.selectionMatches()) this.state.error = true;
        const custom = this.state.mode === 'custom';
        const locked = this.state.pending || this.state.error;
        this.toggle.checked = custom;
        this.toggle.disabled = locked;
        this.toggle.setAttribute('aria-expanded', String(custom));
        this.fields.hidden = !custom;
        this.fields.disabled = !custom;
        this.requestInput.required = custom;
        this.querySelector('[data-custom-sizing-property]').disabled = !custom;
        this.validateMeasurements();
        const message = this.state.error ? this.dataset.errorMessage : this.state.pending ? this.dataset.loadingMessage : this.state.mode === 'choose' ? this.dataset.chooseMessage : '';
        this.status.textContent = message;
        this.status.hidden = !message;
        this.querySelector('[data-measurement-reload]').hidden = !this.state.error;
        const sizeControls = this.controls();
        const submitButtons = Array.from(this.form.elements).filter((node) => node.type === 'submit');
        const controlsToLock = new Set(locked ? [...sizeControls, ...submitButtons] : this.state.mode === 'choose' ? submitButtons : []);
        for (const [node, disabled] of this.locks) {
          if (!controlsToLock.has(node)) { node.disabled = disabled; this.locks.delete(node); }
        }
        controlsToLock.forEach((node) => {
          if (!this.locks.has(node)) this.locks.set(node, node.disabled);
          node.disabled = true;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kk-abaya-measurements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-abaya-measurements')) {
    const sizingDrafts = new Map();
    const currentComponent = (key) => Array.from(document.querySelectorAll('kk-abaya-measurements')).find((node) => node.dataset.instance === key);
    customElements.define('kk-abaya-measurements', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.init(); });
      }
      disconnectedCallback() {
        this.events?.abort();
        this.locks?.forEach((disabled, node) => { if (node.isConnected) node.disabled = disabled; });
        this.hiddenControls?.forEach((node) => node.removeAttribute('data-kk-sizing-hidden'));
      }
      init() {
        this.events?.abort();
        this.events = new AbortController();
        this.locks = new Map();
        this.hiddenControls = [];
        this.toggle = this.querySelector('[data-measurement-toggle]');
        this.fields = this.querySelector('[data-measurement-fields]');
        this.requestInput = this.querySelector('[data-measurement-request]');
        this.specialInput = this.querySelector('[data-special-request]');
        this.specialDetails = this.querySelector('[data-special-details]');
        this.status = this.querySelector('[data-measurement-status]');
        this.form = document.getElementById(this.dataset.form);
        this.picker = Array.from(document.querySelectorAll('variant-picker')).find((node) => node.getAttribute('form-id') === this.dataset.form);
        if (!this.form || !this.picker || typeof this.picker.selectCombination !== 'function' || !this.customControl()) return;
        const selectedSize = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.checked);
        let draft = sizingDrafts.get(this.dataset.instance);
        if (!draft) {
          draft = { mode: selectedSize?.value === this.dataset.customId ? 'custom' : 'standard', lastStandard: selectedSize?.value === this.dataset.customId ? '' : selectedSize?.value, measurements: '', special: '', specialOpen: false, pending: false, error: false };
          sizingDrafts.set(this.dataset.instance, draft);
        }
        this.state = draft;
        this.requestInput.value = draft.measurements;
        this.specialInput.value = draft.special;
        this.specialDetails.open = draft.specialOpen;
        this.querySelector('[data-measurement-toggle-label]').hidden = false;
        const custom = this.customControl();
        this.hideControl(custom);
        Array.from(custom.labels || []).forEach((label) => this.hideControl(label));
        custom.closest('fieldset')?.querySelectorAll('.variant-picker__option-info span').forEach((span) => {
          if (span.textContent.trim() === this.dataset.customValue) this.hideControl(span);
        });
        this.toggle.addEventListener('change', () => this.onToggle(), { signal: this.events.signal });
        this.requestInput.addEventListener('input', () => { draft.measurements = this.requestInput.value; this.validateMeasurements(); }, { signal: this.events.signal });
        this.specialInput.addEventListener('input', () => { draft.special = this.specialInput.value; }, { signal: this.events.signal });
        this.specialDetails.addEventListener('toggle', () => { draft.specialOpen = this.specialDetails.open; }, { signal: this.events.signal });
        document.addEventListener('change', (event) => this.onOptionChange(event), { capture: true, signal: this.events.signal });
        this.form.addEventListener('submit', (event) => this.guardSubmit(event), { capture: true, signal: this.events.signal });
        this.querySelector('[data-measurement-reload]').addEventListener('click', () => window.location.reload(), { signal: this.events.signal });
        this.form.addEventListener('reset', () => queueMicrotask(() => {
          draft.measurements = ''; draft.special = ''; draft.specialOpen = false;
          const active = currentComponent(this.dataset.instance);
          if (active) { active.requestInput.value = ''; active.specialInput.value = ''; active.specialDetails.open = false; active.sync(); }
        }), { signal: this.events.signal });
        this.sync();
      }
      controls() {
        return Array.from(this.form?.elements || []).filter((node) => node.matches('input[data-option-position]'));
      }
      customControl() {
        return this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === this.dataset.customId);
      }
      hideControl(node) {
        node.setAttribute('data-kk-sizing-hidden', '');
        this.hiddenControls.push(node);
      }
      onToggle() {
        if (this.state.pending || this.state.error) { this.sync(); return; }
        if (this.toggle.checked) {
          const standard = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.checked && node.value !== this.dataset.customId);
          if (standard) this.state.lastStandard = standard.value;
          this.state.mode = 'custom';
          this.selectSize(this.dataset.customId);
        } else {
          const previous = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === this.state.lastStandard && !node.disabled);
          this.state.mode = previous ? 'standard' : 'choose';
          if (previous) this.selectSize(previous.value);
          else this.sync();
        }
      }
      onOptionChange(event) {
        const input = event.target;
        if (!input.matches?.('input[data-option-position]') || input.form !== this.form) return;
        event.stopImmediatePropagation();
        if (this.state.pending || this.state.error) return;
        if (input.dataset.optionPosition === this.dataset.sizePosition) {
          this.state.mode = input.value === this.dataset.customId ? 'custom' : 'standard';
          if (this.state.mode === 'standard') this.state.lastStandard = input.value;
        }
        this.selectCombination();
      }
      selectSize(value) {
        const input = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === value);
        if (!input) { this.state.error = true; this.sync(); return; }
        input.checked = true;
        this.selectCombination();
      }
      async selectCombination() {
        const state = this.state;
        const key = this.dataset.instance;
        const optionValues = this.controls().filter((node) => node.checked).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((node) => node.value);
        state.expectedOptions = optionValues.join(',');
        state.pending = true;
        state.error = false;
        this.sync();
        const timer = setTimeout(() => {
          state.error = true;
          currentComponent(key)?.sync();
        }, 15000);
        try {
          await this.picker.selectCombination({ optionValues, productChange: false });
        } catch (error) {
          state.error = true;
        } finally {
          clearTimeout(timer);
          state.pending = false;
          currentComponent(key)?.sync();
        }
      }
      validateMeasurements() {
        this.requestInput.setCustomValidity(this.state.mode === 'custom' && !this.requestInput.value.trim() ? this.dataset.requiredMessage : '');
      }
      selectionMatches() {
        const variant = this.picker.selectedVariant;
        const isCustom = variant?.options?.[Number(this.dataset.sizePosition) - 1] === this.dataset.customValue;
        const variantInput = this.form.elements.namedItem('id');
        const renderedOptions = this.dataset.selectedOptions.split(',').filter(Boolean).join(',');
        const checkedOptions = this.controls().filter((node) => node.checked).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((node) => node.value).join(',');
        const expectedOptions = this.state.expectedOptions || renderedOptions;
        return Boolean(variant?.id && String(variant.id) === variantInput?.value && renderedOptions === expectedOptions && checkedOptions === expectedOptions && (this.state.mode === 'custom' ? isCustom : this.state.mode === 'standard' && !isCustom));
      }
      guardSubmit(event) {
        const blocked = this.state.pending || this.state.error || !this.selectionMatches();
        this.validateMeasurements();
        if (blocked || !this.requestInput.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.sync();
          if (!blocked) this.requestInput.reportValidity();
          else this.status.scrollIntoView({ block: 'nearest' });
        }
      }
      sync() {
        if (!this.state || !this.isConnected) return;
        if (!this.state.pending && this.state.mode !== 'choose' && !this.selectionMatches()) this.state.error = true;
        const custom = this.state.mode === 'custom';
        const locked = this.state.pending || this.state.error;
        this.toggle.checked = custom;
        this.toggle.disabled = locked;
        this.toggle.setAttribute('aria-expanded', String(custom));
        this.fields.hidden = !custom;
        this.fields.disabled = !custom;
        this.requestInput.required = custom;
        this.querySelector('[data-custom-sizing-property]').disabled = !custom;
        this.validateMeasurements();
        const message = this.state.error ? this.dataset.errorMessage : this.state.pending ? this.dataset.loadingMessage : this.state.mode === 'choose' ? this.dataset.chooseMessage : '';
        this.status.textContent = message;
        this.status.hidden = !message;
        this.querySelector('[data-measurement-reload]').hidden = !this.state.error;
        const sizeControls = this.controls();
        const submitButtons = Array.from(this.form.elements).filter((node) => node.type === 'submit');
        const controlsToLock = new Set(locked ? [...sizeControls, ...submitButtons] : this.state.mode === 'choose' ? submitButtons : []);
        for (const [node, disabled] of this.locks) {
          if (!controlsToLock.has(node)) { node.disabled = disabled; this.locks.delete(node); }
        }
        controlsToLock.forEach((node) => {
          if (!this.locks.has(node)) this.locks.set(node, node.disabled);
          node.disabled = true;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kk-display-currency"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-display-currency')) {
    customElements.define('kk-display-currency', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.config = JSON.parse(this.querySelector('script').textContent);
        this.originals = new WeakMap();
        this.formatters = new Map();
        this.state = 'native';
        this.cacheKey = 'kk-display-rates-v1-USD';
        this.retryKey = 'kk-display-rates-retry-v1';
        this.observer = new MutationObserver(() => this.schedule());
        this.observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-kk-money', 'data-kk-currency', 'threshold', 'total-price'] });
        this.onVisible = () => { if (document.visibilityState === 'visible') this.refresh(); };
        document.addEventListener('visibilitychange', this.onVisible);
        this.refresh();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisible);
        clearTimeout(this.timer);
        cancelAnimationFrame(this.frame);
        this.started = false;
      }

      rate(code, data = this.rates) {
        const rates = data?.rates;
        if (!rates) return NaN;
        if (code === 'ANG') return rates.ANG || rates.XCG;
        if (code === 'SLL') return rates.SLL || rates.SLE * 1000;
        if (code === 'STD') return rates.STD || rates.STN * 1000;
        return rates[code];
      }

      valid(data) {
        const now = Date.now() / 1000;
        return data?.result === 'success' && data.base_code === 'USD' && Number.isFinite(data.time_last_update_unix) && data.time_last_update_unix <= now + 300 && now - data.time_last_update_unix < 172800 && (!data.time_eol_unix || data.time_eol_unix > now) && [this.config.native, this.config.display].every(code => Number.isFinite(this.rate(code, data)) && this.rate(code, data) > 0);
      }

      readStorage(key) {
        try { return JSON.parse(localStorage.getItem(key)); } catch { return null; }
      }

      writeStorage(key, value) {
        try { localStorage.setItem(key, JSON.stringify(value)); } catch {}
      }

      async refresh() {
        if (this.loading) return;
        if (this.config.native === this.config.display || this.config.page.startsWith('customers/') || this.config.page === 'gift_card') {
          this.state = 'native';
          this.render();
          return;
        }
        const cached = this.readStorage(this.cacheKey);
        if (this.valid(cached)) {
          this.rates = cached;
          this.state = 'converted';
          this.render();
          if (Date.now() / 1000 < Math.min(cached.time_next_update_unix, cached.time_last_update_unix + 86400)) {
            this.scheduleRefresh(cached.time_next_update_unix);
            return;
          }
        }
        if (Number(this.readStorage(this.retryKey)) > Date.now()) {
          if (!this.valid(this.rates)) this.state = 'unavailable';
          this.render();
          this.scheduleRefresh(Date.now() / 1000 + 3600);
          return;
        }
        this.loading = true;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 5000);
        try {
          const response = await fetch('https://open.er-api.com/v6/latest/USD', { signal: controller.signal, credentials: 'omit', referrerPolicy: 'no-referrer' });
          if (!response.ok) throw new Error('Rate response unavailable');
          const rates = await response.json();
          if (!this.valid(rates)) throw new Error('Rate response invalid');
          this.rates = rates;
          this.writeStorage(this.cacheKey, rates);
          this.writeStorage(this.retryKey, 0);
          this.state = 'converted';
          this.scheduleRefresh(rates.time_next_update_unix);
        } catch {
          this.writeStorage(this.retryKey, Date.now() + 3600000);
          this.state = this.valid(this.rates) ? 'converted' : 'unavailable';
          this.scheduleRefresh(Date.now() / 1000 + 3600);
        } finally {
          clearTimeout(timeout);
          this.loading = false;
          this.render();
        }
      }

      scheduleRefresh(next) {
        clearTimeout(this.timer);
        const delay = Number.isFinite(next) ? Math.max(3600000, Math.min(86400000, next * 1000 - Date.now())) : 3600000;
        this.timer = setTimeout(() => this.refresh(), delay);
      }

      schedule() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.render(); });
      }

      format(amount, currency) {
        if (!this.formatters.has(currency)) this.formatters.set(currency, new Intl.NumberFormat(this.config.locale, { style: 'currency', currency, currencyDisplay: 'code' }));
        return this.formatters.get(currency).format(amount);
      }

      setText(node, text) {
        if (node.textContent !== text) node.textContent = text;
      }

      render() {
        const active = this.state === 'converted' && this.valid(this.rates);
        const currency = active ? this.config.display : this.config.native;
        this.dataset.state = active ? 'converted' : this.state;
        this.dataset.currency = currency;
        document.querySelectorAll('[data-kk-money]').forEach(node => {
          const amount = Number(node.dataset.kkMoney);
          const source = node.dataset.kkCurrency;
          if (!Number.isFinite(amount) || node.dataset.kkMoney === '') return;
          if (!this.originals.has(node)) this.originals.set(node, { html: node.innerHTML, amount, source });
          const original = this.originals.get(node);
          const rate = this.rate(source);
          if (active && Number.isFinite(rate) && rate > 0) {
            this.setText(node, this.format(amount / 100 * this.rate(currency) / rate, currency));
          } else if (original.amount === amount && original.source === source) {
            if (node.innerHTML !== original.html) node.innerHTML = original.html;
          } else {
            this.setText(node, this.format(amount / 100, source));
          }
        });
        document.querySelectorAll('.kk-currency-trigger__label').forEach(node => this.setText(node, node.dataset.kkCountryName ? `${node.dataset.kkCountryName} (${currency})` : currency));
        const note = this.config.unavailable.replaceAll('__NATIVE__', this.config.native);
        document.querySelectorAll('[data-kk-currency-note]').forEach(node => {
          node.hidden = this.state !== 'unavailable';
          this.setText(node, note);
        });
        document.querySelectorAll('[data-kk-checkout-total]').forEach(node => {
          node.hidden = !active;
        });
        document.querySelectorAll('[data-kk-filter-note]').forEach(node => {
          node.hidden = !active;
          this.setText(node, this.config.filterNote.replace('__NATIVE__', this.config.native));
        });
        document.querySelectorAll('[data-kk-currency-attribution]').forEach(node => { node.hidden = !active; });
        document.querySelectorAll('free-shipping-bar').forEach(bar => {
          const amount = Number(bar.getAttribute('threshold')) - Number(bar.getAttribute('total-price'));
          const node = bar.querySelector('span .bold');
          if (amount > 0 && node) this.setText(node, this.format(amount / 100 * (active ? this.rate(currency) / this.rate(this.config.native) : 1), currency));
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kk-home-gift-item"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-home-gift-detail')) {
  customElements.define('kk-home-gift-detail', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.events || !this.querySelector('dialog')) return;
        this.turns = new Map();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.querySelectorAll('[data-kk-open]').forEach(button => { button.hidden = false; });
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-kk-open')) this.open(this);
          if (button.hasAttribute('data-kk-close')) button.closest('dialog').close();
          if (button.hasAttribute('data-kk-view')) this.show(this, button.dataset.kkView);
        }, options);
        const dialog = this.querySelector('dialog');
        dialog.addEventListener('close', () => this.cancelTurn(dialog.querySelector('[data-kk-stage]')), options);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }, options);
        this.resize = new ResizeObserver(() => {
          this.querySelectorAll('dialog[open] [data-kk-stage]').forEach(stage => this.fit(stage));
        });
        this.querySelectorAll('[data-kk-stage]').forEach(stage => this.resize.observe(stage));
      });
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      this.resize?.disconnect();
      this.turns?.forEach((state, stage) => this.cancelTurn(stage));
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
    }
      open(item) {
        const dialog = item.querySelector('dialog');
        const first = item.querySelector('[data-kk-view]');
        if (!dialog || !first) return;
        this.show(item, first.dataset.kkView, false);
        dialog.showModal();
        this.fit(dialog.querySelector('[data-kk-stage]'));
      }
      cancelTurn(stage) {
        const state = this.turns.get(stage);
        if (!state) return;
        state.request += 1;
        state.animations.forEach(animation => animation.cancel());
        state.animations = [];
        state.cleanup?.();
        state.cleanup = null;
        stage.removeAttribute('aria-busy');
        this.fit(stage);
      }
      makeCollection(item, index) {
        const face = document.createElement('div');
        face.className = 'kk-hgd__face kk-hgd__collection';
        face.dataset.collectionView = String(index);
        const frame = document.createElement('div');
        frame.className = 'kk-hgd__collection-frame';
        for (const key of ['3', '2']) {
          const image = item.querySelector(`template[data-kk-detail="${key}"]`)
            ?.content.querySelector('img')?.cloneNode(true);
          if (!image) return null;
          image.loading = 'eager';
          image.decoding = 'async';
          image.classList.remove('kk-hgd__rotated');
          const card = document.createElement('div');
          card.className = 'kk-hgd__card';
          card.dataset.kkCard = key;
          const paper = document.createElement('div');
          paper.className = 'kk-hgd__card-paper';
          paper.appendChild(image);
          card.appendChild(paper);
          frame.appendChild(card);
        }
        face.appendChild(frame);
        return face;
      }
      
      collectionPose(frame, key, view) {
        const width = frame.clientWidth || parseFloat(frame.style.width) || 1;
        const height = frame.clientHeight || parseFloat(frame.style.height) || width * .75;
        const arabic = key === '2';
        const ratio = arabic ? 1.632 : 1.571;
        const cardWidth = width * .86;
        let x, y, scale, angle, opacity = 1, zIndex = 2;
        if (view === '1') {
          scale = (arabic ? .57 : .58) / .86;
          x = width * (arabic ? .334 : .083);
          y = height * (arabic ? .488 : .10);
          angle = arabic ? -.5 : -3;
          zIndex = arabic ? 1 : 2;
        } else if (key === view) {
          scale = 1;
          x = width * .07;
          y = (height - cardWidth / ratio) / 2;
          angle = 0;
          zIndex = 3;
        } else {
          const side = arabic ? -1 : 1;
          scale = .90;
          x = (width - cardWidth * scale) / 2 + side * width * .065;
          y = (height - cardWidth * scale / ratio) / 2 + height * .025;
          angle = side * 2.25;
          opacity = 0;
          zIndex = 1;
        }
        return {
          transform: `translate3d(${x}px, ${y}px, 0) rotate(${angle}deg) scale(${scale})`,
          opacity,
          zIndex,
          filter: 'drop-shadow(0 2px 3px rgba(31,26,23,.08))'
        };
      }
      
      applyCollection(face, index) {
        const frame = face.querySelector('.kk-hgd__collection-frame');
        if (!frame) return;
        face.dataset.collectionView = String(index);
        frame.querySelectorAll('[data-kk-card]').forEach(card => {
          const pose = this.collectionPose(frame, card.dataset.kkCard, String(index));
          Object.assign(card.style, pose);
          card.setAttribute('aria-hidden', String(index !== '1' && card.dataset.kkCard !== String(index)));
        });
      }
      
      async transitionCollection(item, index, state, current) {
        const stage = item.querySelector('[data-kk-stage]');
        const face = stage.querySelector('.kk-hgd__collection');
        const frame = face?.querySelector('.kk-hgd__collection-frame');
        if (!frame) return false;
        const from = face.dataset.collectionView;
        const to = String(index);
        if (from === to) return current();
        const cards = Array.from(frame.querySelectorAll('[data-kk-card]'));
        try {
          await Promise.all(cards.map(card => card.querySelector('img').decode()));
          if (!current()) return false;
          const restore = () => {
            if (stage.contains(face)) this.applyCollection(face, from);
          };
          state.cleanup = restore;
          const moving = cards.map(card => {
            const key = card.dataset.kkCard;
            const start = this.collectionPose(frame, key, from);
            const end = this.collectionPose(frame, key, to);
            const lifting = { filter: 'drop-shadow(0 10px 12px rgba(31,26,23,.13))' };
            let frames;
            if (from !== '1' && to !== '1') {
              const middleView = key === to ? to : from;
              const presented = this.collectionPose(frame, key, middleView);
              const side = key === '2' ? -1 : 1;
              const ratio = key === '2' ? 1.632 : 1.571;
              const width = frame.clientWidth;
              const height = frame.clientHeight;
              const scale = .955;
              const x = (width - width * .86 * scale) / 2 + side * width * .06;
              const y = (height - width * .86 * scale / ratio) / 2 + height * .012;
              const middle = {
                ...presented, ...lifting,
                transform: `translate3d(${x}px, ${y}px, 0) rotate(${side * 1.2}deg) scale(${scale})`,
                opacity: 1
              };
              frames = key === to ? [
                start,
                { ...start, ...lifting, opacity: 1, zIndex: 1, offset: .12 },
                { ...middle, zIndex: 1, offset: .44 },
                { ...middle, zIndex: 4, offset: .46 },
                end
              ] : [
                start,
                { ...middle, zIndex: 3, offset: .44 },
                { ...middle, zIndex: 1, offset: .46 },
                { ...end, opacity: 1, offset: .76 },
                end
              ];
            } else if (to !== '1' && key === to) {
              frames = [start, { ...end, ...lifting, offset: .78 }, end];
            } else if (from !== '1' && key === from) {
              frames = [start, { ...start, ...lifting, offset: .14 }, end];
            } else {
              frames = [start, end];
            }
            const animation = card.animate(frames, {
              duration: 650,
              easing: 'cubic-bezier(.22,.61,.36,1)',
              fill: 'both'
            });
            state.animations.push(animation);
            return animation;
          });
          await Promise.all(moving.map(animation => animation.finished));
          if (!current()) return false;
          this.applyCollection(face, to);
          if (state.cleanup === restore) state.cleanup = null;
          return true;
        } catch {
          return false;
        }
      }
      selectView(item, stage, index) {
        stage.dataset.view = index;
        item.querySelectorAll('[data-kk-view]').forEach(button => {
          const active = button.dataset.kkView === index;
          button.setAttribute('aria-pressed', String(active));
          if (active) item.querySelector('[data-kk-status]').textContent = button.textContent.trim();
        });
      }
      async show(item, index, animate = true) {
        const stage = item.querySelector('[data-kk-stage]');
        if (!stage) return;
        if (!this.turns.has(stage)) this.turns.set(stage, { request: 0, animations: [], cleanup: null });
        this.cancelTurn(stage);
        const state = this.turns.get(stage);
        const request = state.request;
        if (stage.dataset.view === index) return;
        const previous = stage.querySelector('.kk-hgd__face');
        const previousView = stage.dataset.view;
        const collection = item.dataset.kkCardCollection === 'true' && ['1', '2', '3'].includes(index);
        const instant = !animate || !previous || this.motion() === 'instant';
        const current = () => state.request === request && this.isConnected && item.querySelector('dialog').open;
        if (collection && previous?.classList.contains('kk-hgd__collection')) {
          if (instant || !previous.animate) {
            this.applyCollection(previous, index);
            this.selectView(item, stage, index);
            this.fit(stage);
            return;
          }
          stage.setAttribute('aria-busy', 'true');
          try {
            if (await this.transitionCollection(item, index, state, current)) this.selectView(item, stage, index);
          } finally {
            if (state.request === request) this.cancelTurn(stage);
          }
          return;
        }
        const template = item.querySelector(`template[data-kk-detail="${index}"]`);
        const image = template?.content.querySelector('img')?.cloneNode(true);
        if (!image) return;
        let face = collection ? this.makeCollection(item, index) : null;
        if (!face) {
          image.loading = 'eager';
          image.classList.toggle('kk-hgd__rotated', template.dataset.kkRotate === 'true');
          face = document.createElement('div');
          face.className = 'kk-hgd__face';
          face.appendChild(image);
        }
        const commit = () => {
          stage.replaceChildren(face);
          this.selectView(item, stage, index);
          this.fit(stage, true);
        };
        if (instant || !face.animate) {
          commit();
          return;
        }
        stage.setAttribute('aria-busy', 'true');
        try {
          await Promise.all(Array.from(face.querySelectorAll('img'), img => img.decode()));
          if (!current()) return;
          const back = item.dataset.kkBackView;
          const flip = back && back !== 'none' && (index === back || previousView === back);
          const direction = index === back ? 1 : -1;
          const leave = previous.animate(flip ? [
            { transform: 'rotateY(0deg)' },
            { transform: `rotateY(${direction * 88}deg)` }
          ] : [{ opacity: 1 }, { opacity: 0 }], {
            duration: flip ? 260 : 120, easing: 'cubic-bezier(.45,0,.7,.4)', fill: 'forwards'
          });
          state.animations.push(leave);
          await leave.finished;
          if (!current()) return;
          commit();
          const enter = face.animate(flip ? [
            { transform: `rotateY(${-direction * 88}deg)` },
            { transform: 'rotateY(0deg)' }
          ] : [{ opacity: 0 }, { opacity: 1 }], {
            duration: flip ? 340 : 160, easing: 'cubic-bezier(.2,.6,.3,1)', fill: 'both'
          });
          state.animations.push(enter);
          await enter.finished;
        } catch {
        } finally {
          if (state.request === request) this.cancelTurn(stage);
        }
      }
      fit(stage, force = false) {
        const face = stage.querySelector('.kk-hgd__collection');
        if (face) {
          if (stage.hasAttribute('aria-busy') && !force) return;
          const frame = face.querySelector('.kk-hgd__collection-frame');
          const width = Math.min(stage.clientWidth, stage.clientHeight * 4 / 3);
          frame.style.width = `${width}px`;
          frame.style.height = `${width * .75}px`;
          this.applyCollection(face, face.dataset.collectionView);
          return;
        }
        const image = stage.querySelector('.kk-hgd__rotated');
        if (!image || !stage.clientWidth || !stage.clientHeight) return;
        image.style.width = `${stage.clientHeight}px`;
        image.style.height = `${stage.clientWidth}px`;
      }

    motion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kk-jacket-measurements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-jacket-measurements')) {
    const sizingDrafts = new Map();
    const currentComponent = (key) => Array.from(document.querySelectorAll('kk-jacket-measurements')).find((node) => node.dataset.instance === key);
    customElements.define('kk-jacket-measurements', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.init(); });
      }
      disconnectedCallback() {
        this.captureDraft();
        this.events?.abort();
        this.releaseReferencePreviews();
        this.clearSizeFeedback();
        if (this.sizeError) this.append(this.sizeError);
        if (this.sizeFieldset && this.addedSizeTabIndex) this.sizeFieldset.removeAttribute('tabindex');
        this.locks?.forEach((disabled, node) => { if (node.isConnected) node.disabled = disabled; });
        this.hiddenControls?.forEach((node) => node.removeAttribute('data-kk-sizing-hidden'));
      }
      init() {
        this.events?.abort();
        this.events = new AbortController();
        this.locks = new Map();
        this.hiddenControls = [];
        this.toggle = this.querySelector('[data-measurement-toggle]');
        this.fields = this.querySelector('[data-measurement-fields]');
        this.requestInput = this.querySelector('[data-measurement-request]');
        this.typeInputs = Array.from(this.querySelectorAll('[data-measurement-type]'));
        this.unitInputs = Array.from(this.querySelectorAll('[data-measurement-units]'));
        this.numberInputs = Array.from(this.querySelectorAll('[data-measurement-number]'));
        this.specialInput = this.querySelector('[data-special-request]');
        this.specialDetails = this.querySelector('[data-special-details]');
        this.fitInputs = Array.from(this.querySelectorAll('[data-fit-option]'));
        this.otherFitInput = this.querySelector('[data-other-fit]');
        this.uploadInput = this.querySelector('[data-reference-upload]');
        this.status = this.querySelector('[data-measurement-status]');
        this.validateSizeOnSubmit = this.hasAttribute('data-validate-size-on-submit');
        this.sizeError = this.querySelector('[data-size-error]');
        this.form = document.getElementById(this.dataset.form);
        this.picker = Array.from(document.querySelectorAll('variant-picker')).find((node) => node.getAttribute('form-id') === this.dataset.form);
        if (!this.form || !this.picker || typeof this.picker.selectCombination !== 'function' || !this.customControl()) return;
        const selectedSize = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.checked);
        let draft = sizingDrafts.get(this.dataset.instance);
        if (!draft) {
          draft = { mode: !selectedSize && this.validateSizeOnSubmit ? 'choose' : selectedSize?.value === this.dataset.customId ? (this.typeInputs.length ? 'choose' : 'custom') : 'standard', lastStandard: selectedSize?.value === this.dataset.customId ? '' : selectedSize?.value, measurements: '', special: '', specialOpen: false, pending: false, error: false };
          sizingDrafts.set(this.dataset.instance, draft);
        }
        this.state = draft;
        draft.structured ||= { type: '', unit: '', values: {} };
        draft.fit ||= '';
        draft.otherFit ||= '';
        draft.files ||= [];
        if (this.requestInput) this.requestInput.value = draft.measurements;
        if (this.typeInputs.length) {
          this.typeInputs.forEach((input) => { input.checked = input.value === draft.structured.type; });
          this.unitInputs.forEach((input) => { input.checked = input.value === draft.structured.unit; });
          this.numberInputs.forEach((input) => { input.value = draft.structured.values[input.dataset.measurementNumber] || ''; });
          this.typeInputs.forEach((input) => input.addEventListener('change', () => this.changeMeasurementType(), { signal: this.events.signal }));
          this.unitInputs.forEach((input) => input.addEventListener('change', () => this.changeMeasurementUnits(), { signal: this.events.signal }));
          this.numberInputs.forEach((input) => input.addEventListener('input', () => {
            draft.structured.values[input.dataset.measurementNumber] = input.value;
            this.syncStructured();
          }, { signal: this.events.signal }));
        }
        this.specialInput.value = draft.special;
        if (this.specialDetails) this.specialDetails.open = draft.specialOpen;
        this.fitInputs.forEach((input) => {
          input.checked = input.value === draft.fit;
          input.addEventListener('change', () => {
            draft.fit = input.value;
            this.syncCustomisation();
          }, { signal: this.events.signal });
        });
        if (this.otherFitInput) {
          this.otherFitInput.value = draft.otherFit;
          this.otherFitInput.addEventListener('input', () => {
            draft.otherFit = this.otherFitInput.value;
            this.syncCustomisation();
          }, { signal: this.events.signal });
        }
        if (this.uploadInput) {
          this.uploadInput.addEventListener('change', () => this.addReferenceImages(), { signal: this.events.signal });
          this.form.enctype = 'multipart/form-data';
          this.form.addEventListener('formdata', (event) => {
            if (draft.mode !== 'custom') return;
            draft.files.forEach((file, index) => event.formData.append('properties[Reference image ' + (index + 1) + ']', file, file.name));
          }, { signal: this.events.signal });
          this.renderReferenceImages();
        }
        this.querySelector('[data-measurement-toggle-label]').hidden = false;
        const custom = this.customControl();
        this.sizeFieldset = custom.closest('fieldset');
        if (this.validateSizeOnSubmit && this.sizeFieldset && this.sizeError) {
          this.sizeFieldset.append(this.sizeError);
          this.addedSizeTabIndex = !this.sizeFieldset.hasAttribute('tabindex');
          if (this.addedSizeTabIndex) this.sizeFieldset.setAttribute('tabindex', '-1');
        }
        this.hideControl(custom);
        Array.from(custom.labels || []).forEach((label) => this.hideControl(label));
        custom.closest('fieldset')?.querySelectorAll('.variant-picker__option-info span').forEach((span) => {
          if (span.textContent.trim() === this.dataset.customValue) this.hideControl(span);
        });
        this.toggle.addEventListener('change', () => this.onToggle(), { signal: this.events.signal });
        this.requestInput?.addEventListener('input', () => { draft.measurements = this.requestInput.value; this.validateMeasurements(); }, { signal: this.events.signal });
        this.specialInput.addEventListener('input', () => { draft.special = this.specialInput.value; }, { signal: this.events.signal });
        this.specialDetails?.addEventListener('toggle', () => { draft.specialOpen = this.specialDetails.open; }, { signal: this.events.signal });
        document.addEventListener('change', (event) => this.onOptionChange(event), { capture: true, signal: this.events.signal });
        this.form.addEventListener('submit', (event) => this.guardSubmit(event), { capture: true, signal: this.events.signal });
        this.querySelector('[data-measurement-reload]').addEventListener('click', () => window.location.reload(), { signal: this.events.signal });
        this.form.addEventListener('reset', () => queueMicrotask(() => {
          draft.measurements = ''; draft.special = ''; draft.specialOpen = false; draft.structured = { type: '', unit: '', values: {} }; draft.fit = ''; draft.otherFit = ''; draft.files = [];
          const active = currentComponent(this.dataset.instance);
          if (active) {
            if (active.requestInput) active.requestInput.value = '';
            [...active.typeInputs, ...active.unitInputs].forEach((input) => { input.checked = false; });
            active.numberInputs.forEach((input) => { input.value = ''; });
            active.fitInputs.forEach((input) => { input.checked = false; });
            if (active.otherFitInput) active.otherFitInput.value = '';
            if (active.uploadInput) { active.uploadInput.value = ''; active.renderReferenceImages(); }
            active.specialInput.value = ''; if (active.specialDetails) active.specialDetails.open = false; active.sync();
          }
        }), { signal: this.events.signal });
        this.sync();
      }
      controls() {
        return Array.from(this.form?.elements || []).filter((node) => node.matches('input[data-option-position]'));
      }
      customControl() {
        return this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === this.dataset.customId);
      }
      hideControl(node) {
        node.setAttribute('data-kk-sizing-hidden', '');
        this.hiddenControls.push(node);
      }
      captureDraft() {
        if (!this.state) return;
        // Snapshot the fields before hiding or replacing them, including browser autofill.
        if (this.requestInput) this.state.measurements = this.requestInput.value;
        this.state.special = this.specialInput.value;
        if (this.specialDetails) this.state.specialOpen = this.specialDetails.open;
        if (this.typeInputs.length) {
          this.state.structured.type = this.measurementType();
          this.state.structured.unit = this.measurementUnits();
          this.numberInputs.forEach((input) => { this.state.structured.values[input.dataset.measurementNumber] = input.value; });
        }
        this.state.fit = this.fitInputs.find((input) => input.checked)?.value || '';
        if (this.otherFitInput) this.state.otherFit = this.otherFitInput.value;
        // Accepted reference images already live in state.files; the picker is cleared after upload.
      }
      onToggle() {
        if (this.state.pending || this.state.error) { this.sync(); return; }
        this.state.sizeAttempted = false;
        this.clearSizeFeedback();
        this.captureDraft();
        if (this.toggle.checked) {
          const standard = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.checked && node.value !== this.dataset.customId);
          if (standard) this.state.lastStandard = standard.value;
          this.state.mode = 'custom';
          this.selectSize(this.dataset.customId);
        } else {
          const previous = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === this.state.lastStandard && !node.disabled);
          this.state.mode = previous ? 'standard' : 'choose';
          if (previous) this.selectSize(previous.value);
          else this.sync();
        }
      }
      onOptionChange(event) {
        const input = event.target;
        if (!input.matches?.('input[data-option-position]') || input.form !== this.form) return;
        event.stopImmediatePropagation();
        if (this.state.pending || this.state.error) return;
        if (input.dataset.optionPosition === this.dataset.sizePosition) {
          this.state.sizeAttempted = false;
          this.clearSizeFeedback();
          this.state.mode = input.value === this.dataset.customId ? 'custom' : 'standard';
          if (this.state.mode === 'standard') this.state.lastStandard = input.value;
        }
        this.selectCombination();
      }
      selectSize(value) {
        const input = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === value);
        if (!input) { this.state.error = true; this.sync(); return; }
        input.checked = true;
        this.selectCombination();
      }
      async selectCombination() {
        this.captureDraft();
        const state = this.state;
        const key = this.dataset.instance;
        const optionValues = this.controls().filter((node) => node.checked).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((node) => node.value);
        state.expectedOptions = optionValues.join(',');
        state.pending = true;
        state.error = false;
        this.sync();
        const timer = setTimeout(() => {
          state.error = true;
          currentComponent(key)?.sync();
        }, 15000);
        try {
          await this.picker.selectCombination({ optionValues, productChange: false });
        } catch (error) {
          state.error = true;
        } finally {
          clearTimeout(timer);
          state.pending = false;
          currentComponent(key)?.sync();
        }
      }
      validateMeasurements() {
        this.requestInput?.setCustomValidity(this.state.mode === 'custom' && !this.requestInput.value.trim() ? this.dataset.requiredMessage : '');
      }
      measurementType() {
        return this.typeInputs.find((input) => input.checked)?.value || '';
      }
      measurementUnits() {
        return this.unitInputs.find((input) => input.checked)?.value || '';
      }
      changeMeasurementType() {
        const draft = this.state.structured;
        const nextType = this.measurementType();
        const changingType = draft.type && draft.type !== nextType;
        const hadValues = this.numberInputs.some((input) => input.value.trim() !== '');
        if (changingType) {
          draft.values = {};
          this.numberInputs.forEach((input) => { input.value = ''; });
        }
        draft.type = nextType;
        this.measurementFeedback(changingType && hadValues ? this.dataset.typeChangeMessage : '');
        this.syncStructured();
      }
      changeMeasurementUnits() {
        const draft = this.state.structured;
        const nextUnit = this.measurementUnits();
        const hadValues = this.numberInputs.some((input) => input.value.trim() !== '');
        if (draft.unit && nextUnit && draft.unit !== nextUnit) {
          const factor = nextUnit === 'cm' ? 2.54 : 1 / 2.54;
          this.numberInputs.forEach((input) => {
            const value = input.value.trim();
            const converted = Number(value) * factor;
            if (/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)$/.test(value) && Number.isFinite(converted * 100)) input.value = String(Math.round(converted * 100) / 100);
            draft.values[input.dataset.measurementNumber] = input.value;
          });
          this.measurementFeedback(hadValues ? this.dataset.unitChangeMessage : '');
        } else if (!nextUnit) {
          draft.values = {};
          this.numberInputs.forEach((input) => { input.value = ''; });
          this.measurementFeedback('');
        }
        draft.unit = nextUnit;
        this.syncStructured();
      }
      measurementFeedback(message) {
        const feedback = this.querySelector('[data-measurement-feedback]');
        feedback.textContent = message;
        feedback.hidden = !message;
      }
      syncStructured() {
        if (!this.typeInputs.length) return;
        const custom = this.state.mode === 'custom';
        const selectedType = this.measurementType();
        const selectedUnit = this.measurementUnits();
        const type = selectedType === 'Body measurements' ? 'body' : selectedType ? 'garment' : '';
        const ready = Boolean(type && selectedUnit);
        const needsContext = custom && this.numberInputs.some((input) => input.value.trim() !== '');
        [...this.typeInputs, ...this.unitInputs].forEach((input) => { input.required = needsContext; });
        this.querySelector('[data-measurement-intro]').hidden = ready;
        this.querySelector('[data-measurement-guide-intro]').hidden = Boolean(type);
        this.querySelectorAll('[data-measurement-mode]').forEach((node) => { node.hidden = node.dataset.measurementMode !== type; });
        this.querySelectorAll('[data-measurement-diagram]').forEach((node) => { node.hidden = Boolean(type) && node.dataset.measurementDiagram !== type; });
        const propertyNames = !type
          ? { chest: 'Chest/bust', waist: 'Waist', hips: 'Hips', shoulders: 'Shoulder width', sleeve: 'Sleeve length', length: 'Jacket length' }
          : type === 'body'
          ? { chest: 'Chest/bust circumference', waist: 'Waist circumference', hips: 'Hip circumference', shoulders: 'Shoulder width', sleeve: 'Sleeve length', length: 'Desired jacket length' }
          : { chest: 'Chest/bust width (flat)', waist: 'Waist width (flat)', hips: 'Hip width (flat)', shoulders: 'Shoulder width', sleeve: 'Sleeve length', length: 'Jacket length' };
        this.numberInputs.forEach((input) => {
          input.disabled = !custom;
          input.required = false;
          input.name = 'properties[' + propertyNames[input.dataset.measurementNumber] + ']';
          const label = input.closest('.kk-measurements__field').querySelector('[data-measurement-label]');
          label.textContent = !type ? label.dataset.neutralLabel : type === 'garment' ? label.dataset.garmentLabel : label.dataset.bodyLabel;
        });
        this.querySelectorAll('[data-measurement-unit]').forEach((node) => { node.textContent = selectedUnit === 'inches' ? 'in' : selectedUnit === 'cm' ? 'cm' : ''; });
      }
      syncCustomisation() {
        if (!this.otherFitInput) return;
        const custom = this.state.mode === 'custom';
        const other = this.state.fit === 'Other';
        this.querySelector('[data-other-fit-field]').hidden = !other;
        this.otherFitInput.disabled = !custom || !other;
        this.otherFitInput.required = false;
        this.otherFitInput.setCustomValidity('');
      }
      addReferenceImages() {
        const selected = Array.from(this.uploadInput.files || []);
        const feedback = this.querySelector('[data-upload-error]');
        const unique = selected.filter((file) => !this.state.files.some((saved) => saved.name === file.name && saved.size === file.size && saved.lastModified === file.lastModified));
        let error = '';
        if (this.state.files.length + unique.length > 3) error = this.dataset.uploadLimitMessage;
        else if (unique.some((file) => !['image/jpeg', 'image/png', 'image/webp'].includes(file.type))) error = this.dataset.uploadTypeMessage;
        else if (unique.some((file) => file.size > 5 * 1024 * 1024)) error = this.dataset.uploadSizeMessage;
        if (!error) this.state.files.push(...unique);
        this.uploadInput.value = '';
        feedback.textContent = error;
        feedback.hidden = !error;
        this.renderReferenceImages();
      }
      releaseReferencePreviews() {
        this.previewUrls?.forEach((url) => URL.revokeObjectURL(url));
        this.previewUrls = [];
      }
      renderReferenceImages() {
        const list = this.querySelector('[data-reference-list]');
        if (!list) return;
        this.releaseReferencePreviews();
        list.replaceChildren();
        list.hidden = this.state.files.length === 0;
        this.state.files.forEach((file, index) => {
          const item = document.createElement('li');
          const preview = document.createElement('img');
          const url = URL.createObjectURL(file);
          this.previewUrls.push(url);
          preview.src = url;
          preview.alt = '';
          const filename = document.createElement('span');
          filename.textContent = file.name;
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.textContent = this.dataset.removeImageLabel;
          remove.setAttribute('aria-label', this.dataset.removeImageLabel + ' ' + file.name);
          remove.addEventListener('click', () => {
            this.state.files.splice(index, 1);
            this.querySelector('[data-upload-error]').hidden = true;
            this.renderReferenceImages();
          }, { signal: this.events.signal });
          item.append(preview, filename, remove);
          list.append(item);
        });
      }
      selectionMatches() {
        const variant = this.picker.selectedVariant;
        const isCustom = variant?.options?.[Number(this.dataset.sizePosition) - 1] === this.dataset.customValue;
        const variantInput = this.form.elements.namedItem('id');
        const renderedOptions = this.dataset.selectedOptions.split(',').filter(Boolean).join(',');
        const checkedOptions = this.controls().filter((node) => node.checked).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((node) => node.value).join(',');
        const expectedOptions = this.state.expectedOptions || renderedOptions;
        return Boolean(variant?.id && String(variant.id) === variantInput?.value && renderedOptions === expectedOptions && checkedOptions === expectedOptions && (this.state.mode === 'custom' ? isCustom : this.state.mode === 'standard' && !isCustom));
      }
      clearSizeFeedback() {
        if (this.sizeError) this.sizeError.hidden = true;
        if (!this.sizeFieldset || !this.sizeError) return;
        this.sizeFieldset.classList.remove('kk-jacket-size-missing');
        this.sizeFieldset.removeAttribute('aria-invalid');
        const descriptions = (this.sizeFieldset.getAttribute('aria-describedby') || '').split(/\s+/).filter((id) => id && id !== this.sizeError.id);
        if (descriptions.length) this.sizeFieldset.setAttribute('aria-describedby', descriptions.join(' '));
        else this.sizeFieldset.removeAttribute('aria-describedby');
      }
      syncSizeFeedback() {
        if (!this.validateSizeOnSubmit || !this.sizeError || !this.sizeFieldset) return;
        if (this.state.mode !== 'choose' || !this.state.sizeAttempted || this.state.pending || this.state.error) {
          this.clearSizeFeedback();
          return;
        }
        this.sizeError.hidden = false;
        this.sizeFieldset.classList.add('kk-jacket-size-missing');
        this.sizeFieldset.setAttribute('aria-invalid', 'true');
        const descriptions = new Set((this.sizeFieldset.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
        descriptions.add(this.sizeError.id);
        this.sizeFieldset.setAttribute('aria-describedby', [...descriptions].join(' '));
      }
      guardSubmit(event) {
        if (this.validateSizeOnSubmit && this.state.mode === 'choose' && !this.state.pending && !this.state.error) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.state.sizeAttempted = true;
          this.sync();
          // Focus the group without selecting a radio on the customer's behalf.
          const target = this.sizeFieldset || this.toggle;
          target.focus({ preventScroll: true });
          target.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          return;
        }
        const blocked = this.state.pending || this.state.error || !this.selectionMatches();
        this.validateMeasurements();
        this.syncStructured();
        this.syncCustomisation();
        const invalidInput = Array.from(this.fields.querySelectorAll('input, select, textarea')).find((input) => !input.checkValidity());
        if (blocked || invalidInput) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.sync();
          if (!blocked) invalidInput.reportValidity();
          else this.status.scrollIntoView({ block: 'nearest' });
        }
      }
      sync() {
        if (!this.state || !this.isConnected) return;
        if (!this.state.pending && this.state.mode !== 'choose' && !this.selectionMatches()) this.state.error = true;
        const custom = this.state.mode === 'custom';
        const locked = this.state.pending || this.state.error;
        this.toggle.checked = custom;
        this.toggle.disabled = locked;
        this.toggle.setAttribute('aria-expanded', String(custom));
        this.fields.hidden = !custom;
        this.fields.disabled = !custom;
        if (this.requestInput) this.requestInput.required = custom;
        this.syncStructured();
        this.syncCustomisation();
        this.querySelector('[data-custom-sizing-property]').disabled = !custom;
        this.validateMeasurements();
        const message = this.state.error ? this.dataset.errorMessage : this.state.pending ? this.dataset.loadingMessage : this.state.mode === 'choose' && !this.validateSizeOnSubmit ? this.dataset.chooseMessage : '';
        this.status.textContent = message;
        this.status.hidden = !message;
        this.querySelector('[data-measurement-reload]').hidden = !this.state.error;
        this.syncSizeFeedback();
        const sizeControls = this.controls();
        const submitButtons = Array.from(this.form.elements).filter((node) => node.type === 'submit');
        const controlsToLock = new Set(locked ? [...sizeControls, ...submitButtons] : this.state.mode === 'choose' && !this.validateSizeOnSubmit ? submitButtons : []);
        for (const [node, disabled] of this.locks) {
          if (!controlsToLock.has(node)) { node.disabled = disabled; this.locks.delete(node); }
        }
        controlsToLock.forEach((node) => {
          if (!this.locks.has(node)) this.locks.set(node, node.disabled);
          node.disabled = true;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kk-kaftan-measurements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-kaftan-measurements')) {
    const sizingDrafts = new Map();
    const currentComponent = (key) => Array.from(document.querySelectorAll('kk-kaftan-measurements')).find((node) => node.dataset.instance === key);
    customElements.define('kk-kaftan-measurements', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.init(); });
      }
      disconnectedCallback() {
        this.events?.abort();
        this.locks?.forEach((disabled, node) => { if (node.isConnected) node.disabled = disabled; });
        this.hiddenControls?.forEach((node) => node.removeAttribute('data-kk-sizing-hidden'));
      }
      init() {
        this.events?.abort();
        this.events = new AbortController();
        this.locks = new Map();
        this.hiddenControls = [];
        this.toggle = this.querySelector('[data-measurement-toggle]');
        this.fields = this.querySelector('[data-measurement-fields]');
        this.requestInput = this.querySelector('[data-measurement-request]');
        this.specialInput = this.querySelector('[data-special-request]');
        this.specialDetails = this.querySelector('[data-special-details]');
        this.status = this.querySelector('[data-measurement-status]');
        this.form = document.getElementById(this.dataset.form);
        this.picker = Array.from(document.querySelectorAll('variant-picker')).find((node) => node.getAttribute('form-id') === this.dataset.form);
        if (!this.form || !this.picker || typeof this.picker.selectCombination !== 'function' || !this.customControl()) return;
        const selectedSize = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.checked);
        let draft = sizingDrafts.get(this.dataset.instance);
        if (!draft) {
          draft = { mode: selectedSize?.value === this.dataset.customId ? 'custom' : 'standard', lastStandard: selectedSize?.value === this.dataset.customId ? '' : selectedSize?.value, measurements: '', special: '', specialOpen: false, pending: false, error: false };
          sizingDrafts.set(this.dataset.instance, draft);
        }
        this.state = draft;
        this.requestInput.value = draft.measurements;
        this.specialInput.value = draft.special;
        this.specialDetails.open = draft.specialOpen;
        this.querySelector('[data-measurement-toggle-label]').hidden = false;
        const custom = this.customControl();
        this.hideControl(custom);
        Array.from(custom.labels || []).forEach((label) => this.hideControl(label));
        custom.closest('fieldset')?.querySelectorAll('.variant-picker__option-info span').forEach((span) => {
          if (span.textContent.trim() === this.dataset.customValue) this.hideControl(span);
        });
        this.toggle.addEventListener('change', () => this.onToggle(), { signal: this.events.signal });
        this.requestInput.addEventListener('input', () => { draft.measurements = this.requestInput.value; this.validateMeasurements(); }, { signal: this.events.signal });
        this.specialInput.addEventListener('input', () => { draft.special = this.specialInput.value; }, { signal: this.events.signal });
        this.specialDetails.addEventListener('toggle', () => { draft.specialOpen = this.specialDetails.open; }, { signal: this.events.signal });
        document.addEventListener('change', (event) => this.onOptionChange(event), { capture: true, signal: this.events.signal });
        this.form.addEventListener('submit', (event) => this.guardSubmit(event), { capture: true, signal: this.events.signal });
        this.querySelector('[data-measurement-reload]').addEventListener('click', () => window.location.reload(), { signal: this.events.signal });
        this.form.addEventListener('reset', () => queueMicrotask(() => {
          draft.measurements = ''; draft.special = ''; draft.specialOpen = false;
          const active = currentComponent(this.dataset.instance);
          if (active) { active.requestInput.value = ''; active.specialInput.value = ''; active.specialDetails.open = false; active.sync(); }
        }), { signal: this.events.signal });
        this.sync();
      }
      controls() {
        return Array.from(this.form?.elements || []).filter((node) => node.matches('input[data-option-position]'));
      }
      customControl() {
        return this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === this.dataset.customId);
      }
      hideControl(node) {
        node.setAttribute('data-kk-sizing-hidden', '');
        this.hiddenControls.push(node);
      }
      onToggle() {
        if (this.state.pending || this.state.error) { this.sync(); return; }
        if (this.toggle.checked) {
          const standard = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.checked && node.value !== this.dataset.customId);
          if (standard) this.state.lastStandard = standard.value;
          this.state.mode = 'custom';
          this.selectSize(this.dataset.customId);
        } else {
          const previous = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === this.state.lastStandard && !node.disabled);
          this.state.mode = previous ? 'standard' : 'choose';
          if (previous) this.selectSize(previous.value);
          else this.sync();
        }
      }
      onOptionChange(event) {
        const input = event.target;
        if (!input.matches?.('input[data-option-position]') || input.form !== this.form) return;
        event.stopImmediatePropagation();
        if (this.state.pending || this.state.error) return;
        if (input.dataset.optionPosition === this.dataset.sizePosition) {
          this.state.mode = input.value === this.dataset.customId ? 'custom' : 'standard';
          if (this.state.mode === 'standard') this.state.lastStandard = input.value;
        }
        this.selectCombination();
      }
      selectSize(value) {
        const input = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === value);
        if (!input) { this.state.error = true; this.sync(); return; }
        input.checked = true;
        this.selectCombination();
      }
      async selectCombination() {
        const state = this.state;
        const key = this.dataset.instance;
        const optionValues = this.controls().filter((node) => node.checked).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((node) => node.value);
        state.expectedOptions = optionValues.join(',');
        state.pending = true;
        state.error = false;
        this.sync();
        const timer = setTimeout(() => {
          state.error = true;
          currentComponent(key)?.sync();
        }, 15000);
        try {
          await this.picker.selectCombination({ optionValues, productChange: false });
        } catch (error) {
          state.error = true;
        } finally {
          clearTimeout(timer);
          state.pending = false;
          currentComponent(key)?.sync();
        }
      }
      validateMeasurements() {
        this.requestInput.setCustomValidity(this.state.mode === 'custom' && !this.requestInput.value.trim() ? this.dataset.requiredMessage : '');
      }
      selectionMatches() {
        const variant = this.picker.selectedVariant;
        const isCustom = variant?.options?.[Number(this.dataset.sizePosition) - 1] === this.dataset.customValue;
        const variantInput = this.form.elements.namedItem('id');
        const renderedOptions = this.dataset.selectedOptions.split(',').filter(Boolean).join(',');
        const checkedOptions = this.controls().filter((node) => node.checked).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((node) => node.value).join(',');
        const expectedOptions = this.state.expectedOptions || renderedOptions;
        return Boolean(variant?.id && String(variant.id) === variantInput?.value && renderedOptions === expectedOptions && checkedOptions === expectedOptions && (this.state.mode === 'custom' ? isCustom : this.state.mode === 'standard' && !isCustom));
      }
      guardSubmit(event) {
        const blocked = this.state.pending || this.state.error || !this.selectionMatches();
        this.validateMeasurements();
        if (blocked || !this.requestInput.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.sync();
          if (!blocked) this.requestInput.reportValidity();
          else this.status.scrollIntoView({ block: 'nearest' });
        }
      }
      sync() {
        if (!this.state || !this.isConnected) return;
        if (!this.state.pending && this.state.mode !== 'choose' && !this.selectionMatches()) this.state.error = true;
        const custom = this.state.mode === 'custom';
        const locked = this.state.pending || this.state.error;
        this.toggle.checked = custom;
        this.toggle.disabled = locked;
        this.toggle.setAttribute('aria-expanded', String(custom));
        this.fields.hidden = !custom;
        this.fields.disabled = !custom;
        this.requestInput.required = custom;
        this.querySelector('[data-custom-sizing-property]').disabled = !custom;
        this.validateMeasurements();
        const message = this.state.error ? this.dataset.errorMessage : this.state.pending ? this.dataset.loadingMessage : this.state.mode === 'choose' ? this.dataset.chooseMessage : '';
        this.status.textContent = message;
        this.status.hidden = !message;
        this.querySelector('[data-measurement-reload]').hidden = !this.state.error;
        const sizeControls = this.controls();
        const submitButtons = Array.from(this.form.elements).filter((node) => node.type === 'submit');
        const controlsToLock = new Set(locked ? [...sizeControls, ...submitButtons] : this.state.mode === 'choose' ? submitButtons : []);
        for (const [node, disabled] of this.locks) {
          if (!controlsToLock.has(node)) { node.disabled = disabled; this.locks.delete(node); }
        }
        controlsToLock.forEach((node) => {
          if (!this.locks.has(node)) this.locks.set(node, node.disabled);
          node.disabled = true;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kk-machine-shawl-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-machine-shawl-delivery')) {
    customElements.define('kk-machine-shawl-delivery', class extends HTMLElement {
      connectedCallback() {
        this._abortController?.abort();
        this._abortController = new AbortController();
        const signal = this._abortController.signal;
        this.addEventListener('input', (event) => {
          if (!event.target.matches('.kk-ms-delivery__search')) return;
          const query = event.target.value.toLocaleLowerCase().trim();
          let visibleCount = 0;
          this.querySelectorAll('[data-search]').forEach((option) => {
            const visible = option.dataset.search.toLocaleLowerCase().includes(query);
            option.hidden = !visible;
            if (visible) visibleCount += 1;
          });
          const empty = this.querySelector('.kk-ms-delivery__empty');
          if (empty) empty.hidden = visibleCount !== 0;
        }, { signal });
        this.addEventListener('submit', (event) => {
          const returnTo = event.target.querySelector('[name="return_to"]');
          if (returnTo) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.delete('country');
            returnTo.value = currentUrl.pathname + currentUrl.search + currentUrl.hash;
          }
        }, { signal });
      }
      disconnectedCallback() {
        this._abortController?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kk-machine-suit-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-suit-arrival-date')) {
    customElements.define('kk-suit-arrival-date', class extends HTMLElement {
      connectedCallback() {
        const time = this.querySelector('time');
        if (!time) return;
        const arrival = new Date();
        arrival.setDate(arrival.getDate() + 20);
        time.dateTime = [arrival.getFullYear(), String(arrival.getMonth() + 1).padStart(2, '0'), String(arrival.getDate()).padStart(2, '0')].join('-');
        time.textContent = new Intl.DateTimeFormat(document.documentElement.lang || undefined, { month: 'short', day: 'numeric' }).format(arrival);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kk-order-lookup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-order-lookup')) {
    customElements.define('kk-order-lookup', class extends HTMLElement {
      connectedCallback() {
        this.lifecycle?.abort();
        this.lifecycle = new AbortController();
        this.form = this.querySelector('form');
        this.orderInput = this.querySelector('[name="orderNumber"]');
        this.emailInput = this.querySelector('[name="email"]');
        this.button = this.querySelector('button');
        this.status = this.querySelector('.kk-order-lookup__status');
        this.error = this.querySelector('.kk-order-lookup__form-error');
        this.results = this.querySelector('.kk-order-lookup__results');
        this.form.noValidate = true;
        this.form.hidden = false;
        this.reset();
        this.form.addEventListener('submit', (event) => this.lookup(event), { signal: this.lifecycle.signal });
        this.form.addEventListener('input', () => this.reset(), { signal: this.lifecycle.signal });
      }

      disconnectedCallback() {
        this.requestId++;
        this.request?.abort();
        this.lifecycle?.abort();
        clearTimeout(this.timeout);
      }

      busy(active) {
        this.button.disabled = active;
        this.form.setAttribute('aria-busy', String(active));
        this.status.textContent = active ? this.dataset.loading : '';
      }

      reset() {
        this.requestId = (this.requestId || 0) + 1;
        this.request?.abort();
        clearTimeout(this.timeout);
        this.busy(false);
        [this.orderInput, this.emailInput].forEach((input) => input.removeAttribute('aria-invalid'));
        this.querySelectorAll('[data-field-error]').forEach((error) => { error.textContent = ''; error.hidden = true; });
        this.error.textContent = '';
        this.error.hidden = true;
        this.results.replaceChildren();
        this.results.hidden = true;
      }

      fieldError(input, message) {
        const error = this.querySelector('[data-field-error="' + input.name + '"]');
        input.setAttribute('aria-invalid', 'true');
        error.textContent = message;
        error.hidden = false;
      }

      showError(message) {
        this.busy(false);
        this.error.textContent = message;
        this.error.hidden = false;
      }

      element(tag, text, className) {
        const element = document.createElement(tag);
        if (text) element.textContent = text;
        if (className) element.className = className;
        return element;
      }

      safeUrl(raw) {
        if (typeof raw !== 'string' || raw.length > 2048) return null;
        try {
          const url = new URL(raw);
          return url.protocol === 'https:' && !url.username && !url.password ? url.href : null;
        } catch { return null; }
      }

      showOrder(order) {
        const text = (value, limit = 200) => typeof value === 'string' ? value.slice(0, limit) : '';
        const fulfillment = {
          FULFILLED: 'fulfillmentFulfilled', PARTIALLY_FULFILLED: 'fulfillmentPartial',
          UNFULFILLED: 'fulfillmentUnfulfilled', ON_HOLD: 'fulfillmentOnHold',
          IN_PROGRESS: 'fulfillmentProgress', PENDING_FULFILLMENT: 'fulfillmentProgress',
          OPEN: 'fulfillmentProgress', SCHEDULED: 'fulfillmentProgress', REQUEST_DECLINED: 'fulfillmentOnHold'
        };
        const states = {
          CONFIRMED: 'statusConfirmed', IN_TRANSIT: 'statusTransit', CARRIER_PICKED_UP: 'statusTransit',
          PICKED_UP: 'statusTransit', OUT_FOR_DELIVERY: 'statusDelivery', DELIVERED: 'statusDelivered',
          ATTEMPTED_DELIVERY: 'statusAttempted', READY_FOR_PICKUP: 'statusPickup',
          LABEL_PRINTED: 'statusLabel', LABEL_PURCHASED: 'statusLabel', DELAYED: 'statusDelayed', FAILURE: 'statusIssue'
        };
        this.results.append(this.element('h2', this.dataset.order + ' ' + text(order.number, 80), 'h4'));
        if (order.cancelled === true) this.results.append(this.element('p', this.dataset.cancelled));
        else if (fulfillment[order.fulfillmentStatus]) this.results.append(this.element('p', this.dataset[fulfillment[order.fulfillmentStatus]]));
        const shipments = Array.isArray(order.shipments) ? order.shipments.filter((item) => item && typeof item === 'object').slice(0, 50) : [];
        if (!shipments.length && order.cancelled !== true) this.results.append(this.element('p', this.dataset.pending));
        if (shipments.length) {
          const parcels = this.element('ol', '', 'kk-order-lookup__parcels');
          shipments.forEach((shipment, index) => {
            const parcel = this.element('li', '', 'kk-order-lookup__parcel');
            parcel.append(this.element('h3', this.dataset.parcel + ' ' + (index + 1)));
            const details = this.element('dl');
            const addDetail = (label, value) => { if (value) details.append(this.element('dt', label), this.element('dd', value)); };
            addDetail(this.dataset.carrier, text(shipment.carrier));
            const number = text(shipment.trackingNumber, 100);
            addDetail(this.dataset.number, number);
            addDetail(this.dataset.shipmentStatus, this.dataset[states[shipment.status]]);
            parcel.append(details);
            const suppliedUrl = this.safeUrl(shipment.trackingUrl);
            const url = suppliedUrl || (number ? 'https://t.17track.net/en#nums=' + encodeURIComponent(number) : null);
            if (url) {
              const link = this.element('a', suppliedUrl ? this.dataset.track : this.dataset.provider, 'link');
              link.href = url;
              link.target = '_blank';
              link.rel = 'noopener noreferrer';
              link.append(this.element('span', ' ' + this.dataset.newTab, 'sr-only'));
              parcel.append(link);
            } else parcel.append(this.element('p', this.dataset.pending));
            parcels.append(parcel);
          });
          this.results.append(parcels);
        }
        this.results.hidden = false;
        this.status.textContent = this.dataset.found;
        this.results.focus({ preventScroll: true });
      }

      async lookup(event) {
        event.preventDefault();
        this.reset();
        const orderNumber = this.orderInput.value.trim().replace(/^#/, '').trim();
        const email = this.emailInput.value.trim();
        this.emailInput.value = email;
        if (!orderNumber) this.fieldError(this.orderInput, this.dataset.orderRequired);
        else if (!/^[a-z0-9][a-z0-9 _.-]{0,79}$/i.test(orderNumber)) this.fieldError(this.orderInput, this.dataset.orderInvalid);
        if (!email) this.fieldError(this.emailInput, this.dataset.emailRequired);
        else if (email.length > 254 || this.emailInput.validity.typeMismatch || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) this.fieldError(this.emailInput, this.dataset.emailInvalid);
        const invalid = this.form.querySelector('[aria-invalid="true"]');
        if (invalid) { invalid.focus(); return; }
        let endpoint;
        try {
          endpoint = new URL(this.dataset.endpoint, location.origin);
          if (endpoint.origin !== location.origin || !endpoint.pathname.startsWith('/apps/') || endpoint.search || endpoint.hash || endpoint.username || endpoint.password) throw new Error();
        } catch { this.showError(this.dataset.unavailable); return; }
        const requestId = this.requestId;
        const current = () => this.isConnected && this.requestId === requestId;
        this.request = new AbortController();
        this.timeout = setTimeout(() => this.request?.abort(), 15000);
        this.busy(true);
        try {
          const response = await fetch(endpoint.href, {
            method: 'POST', mode: 'same-origin', credentials: 'same-origin', cache: 'no-store', redirect: 'error',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ orderNumber, email }), signal: this.request.signal
          });
          const data = await response.json();
          if (!current()) return;
          clearTimeout(this.timeout);
          this.busy(false);
          if (response.ok && data?.status === 'found' && data.order && typeof data.order === 'object') this.showOrder(data.order);
          else {
            const messages = { not_found: 'notFound', rate_limited: 'rateLimited', invalid: 'invalid', unavailable: 'unavailable' };
            const key = response.status === 429 ? 'rateLimited' : messages[data?.status] || 'unavailable';
            this.showError(this.dataset[key]);
          }
        } catch {
          if (current()) this.showError(this.dataset.unavailable);
        } finally {
          if (current()) clearTimeout(this.timeout);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kk-order-tracking"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-order-tracking')) {
    let trackerPromise;
    const loadTracker = () => {
      if (window.YQV5?.trackSingle) return Promise.resolve(window.YQV5);
      if (!trackerPromise) {
        trackerPromise = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://www.17track.net/externalcall.js';
          script.async = true;
          const fail = () => { clearTimeout(timer); script.remove(); reject(new Error('Tracking unavailable')); };
          const timer = setTimeout(fail, 12000);
          script.onload = () => {
            clearTimeout(timer);
            if (window.YQV5?.trackSingle) resolve(window.YQV5);
            else fail();
          };
          script.onerror = fail;
          document.head.appendChild(script);
        }).catch((error) => { trackerPromise = undefined; throw error; });
      }
      return trackerPromise;
    };

    customElements.define('kk-order-tracking', class extends HTMLElement {
      connectedCallback() {
        this.requestId = (this.requestId || 0) + 1;
        this.controller = new AbortController();
        this.form = this.querySelector('form');
        this.input = this.querySelector('input');
        this.button = this.querySelector('button');
        this.error = this.querySelector('.kk-tracking__error');
        this.status = this.querySelector('.kk-tracking__status');
        this.results = this.querySelector('.kk-tracking__results');
        this.widget = this.querySelector('.kk-tracking__widget');
        this.fallback = this.querySelector('.kk-tracking__fallback');
        this.form.noValidate = true;
        this.form.addEventListener('submit', (event) => this.track(event), { signal: this.controller.signal });
        this.input.addEventListener('input', () => this.reset(), { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.requestId++;
        this.controller?.abort();
        clearTimeout(this.resultTimer);
      }

      busy(active) {
        this.button.disabled = active;
        this.form.setAttribute('aria-busy', String(active));
        this.widget.setAttribute('aria-busy', String(active));
        this.status.textContent = active ? this.dataset.loading : '';
      }

      reset() {
        this.requestId++;
        clearTimeout(this.resultTimer);
        this.busy(false);
        this.input.removeAttribute('aria-invalid');
        this.error.textContent = '';
        this.error.hidden = true;
        this.results.hidden = true;
        this.widget.replaceChildren();
        this.fallback.hidden = true;
      }

      showError(message, invalid = false) {
        this.busy(false);
        this.error.textContent = message;
        this.error.hidden = false;
        if (invalid) {
          this.input.setAttribute('aria-invalid', 'true');
          this.input.focus();
        }
      }

      async track(event) {
        event.preventDefault();
        this.reset();
        const number = this.input.value.trim();
        if (!number) return this.showError(this.dataset.empty, true);
        if (!/^[a-z0-9-]{3,50}$/i.test(number)) return this.showError(this.dataset.invalid, true);
        this.input.value = number;
        const requestId = this.requestId;
        const current = () => this.isConnected && this.requestId === requestId;
        this.fallback.href = 'https://t.17track.net/en#nums=' + encodeURIComponent(number);
        this.fallback.hidden = false;
        this.busy(true);
        try {
          const tracker = await loadTracker();
          if (!current()) return;
          this.results.hidden = false;
          this.resultTimer = setTimeout(() => {
            if (current()) this.showError(this.dataset.unavailable);
          }, 20000);
          tracker.trackSingle({
            YQ_ContainerId: this.widget.id,
            YQ_Height: 560,
            YQ_Fc: '0',
            YQ_Lang: 'en',
            YQ_Num: number,
            onLoaded: () => {
              if (!current()) return;
              clearTimeout(this.resultTimer);
              this.busy(false);
              this.error.textContent = '';
              this.error.hidden = true;
            }
          });
          const frame = this.widget.querySelector('iframe');
          if (!frame) throw new Error('Tracking frame unavailable');
          frame.title = this.widget.getAttribute('aria-label');
        } catch {
          if (current()) {
            clearTimeout(this.resultTimer);
            this.showError(this.dataset.unavailable);
          }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kk-pashmina-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-pashmina-delivery')) {
    customElements.define('kk-pashmina-delivery', class extends HTMLElement {
      connectedCallback() {
        this._abortController?.abort();
        this._abortController = new AbortController();
        const signal = this._abortController.signal;
        this.addEventListener('input', (event) => {
          if (!event.target.matches('.kk-pd__search')) return;
          const query = event.target.value.toLocaleLowerCase().trim();
          let visibleCount = 0;
          this.querySelectorAll('[data-search]').forEach((option) => {
            const visible = option.dataset.search.toLocaleLowerCase().includes(query);
            option.hidden = !visible;
            if (visible) visibleCount += 1;
          });
          const empty = this.querySelector('.kk-pd__empty');
          if (empty) empty.hidden = visibleCount !== 0;
        }, { signal });
        this.addEventListener('submit', (event) => {
          const returnTo = event.target.querySelector('[name="return_to"]');
          if (returnTo) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.delete('country');
            returnTo.value = currentUrl.pathname + currentUrl.search + currentUrl.hash;
          }
        }, { signal });
      }
      disconnectedCallback() {
        this._abortController?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kk-pheran-fit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-pheran-fit')) {
    customElements.define('kk-pheran-fit', class extends HTMLElement {
      static states = new Map();

      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.initialize(); });
      }

      initialize() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.formId = this.dataset.productForm;
        this.disclosure = this.querySelector('details');
        this.fields = [...this.querySelectorAll('[data-fit-field]')];
        this.measurements = [...this.querySelectorAll('[data-fit-measurement]')];
        this.later = this.querySelector('[data-fit-field="later"]');
        this.units = this.querySelector('[data-fit-field="units"]');
        this.isCustom = this.dataset.customSelected === 'true';
        const previous = this.constructor.states.get(this.formId);
        if (previous) {
          this.fields.forEach(field => {
            const value = previous.values[field.dataset.fitField];
            if (value === undefined) return;
            if (field.type === 'checkbox') field.checked = value;
            else field.value = value;
          });
          this.disclosure.open = this.isCustom && (!previous.custom || previous.open);
        }
        this.previousUnits = this.units.value;
        this.applyState();
        this.addEventListener('input', () => this.remember(), options);
        this.addEventListener('change', event => {
          if (event.target === this.units) this.convertMeasurements();
          this.applyState();
          this.remember();
        }, options);
        this.disclosure.addEventListener('toggle', () => this.remember(), options);
        this.addEventListener('invalid', () => { this.disclosure.open = true; }, { ...options, capture: true });
        document.addEventListener('variant:change', event => this.handleVariantChange(event), options);
        document.addEventListener('change', event => this.handleOptionChange(event), { ...options, capture: true });
        document.addEventListener('submit', event => this.validateSubmission(event), { ...options, capture: true });
        this.remember();
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      remember() {
        const values = {};
        this.fields.forEach(field => {
          values[field.dataset.fitField] = field.type === 'checkbox' ? field.checked : field.value;
        });
        this.constructor.states.set(this.formId, { values, open: this.disclosure.open, custom: this.isCustom });
      }

      applyState() {
        const measurementsActive = this.isCustom && !this.later.checked;
        this.hidden = !this.isCustom;
        this.fields.forEach(field => { field.disabled = !this.isCustom; });
        this.units.disabled = !measurementsActive;
        this.measurements.forEach(field => {
          field.disabled = !measurementsActive;
          field.required = measurementsActive && field.dataset.fitRequired === 'true';
        });
        this.querySelector('[data-fit-measurements]').hidden = this.later.checked;
        this.querySelector('[data-fit-later-note]').hidden = !this.later.checked;
      }

      convertMeasurements() {
        if (this.units.value === this.previousUnits) return;
        const factor = this.units.value === 'cm' ? 2.54 : 1 / 2.54;
        this.measurements.forEach(field => {
          if (field.value === '' || !Number.isFinite(field.valueAsNumber)) return;
          field.value = String(Math.round(field.valueAsNumber * factor * 100) / 100);
        });
        this.previousUnits = this.units.value;
      }

      handleVariantChange(event) {
        if (event.target.getAttribute?.('id') !== this.formId && event.detail?.formId !== this.formId) return;
        const variant = event.detail?.variant;
        const index = Number(this.dataset.sizeIndex);
        const value = variant?.options?.[index] ?? variant?.[`option${index + 1}`];
        const wasCustom = this.isCustom;
        this.isCustom = value === this.dataset.customValue;
        if (this.isCustom && !wasCustom) this.disclosure.open = true;
        this.applyState();
        this.remember();
      }

      handleOptionChange(event) {
        const control = event.target;
        if (control.form?.getAttribute('id') !== this.formId || control.dataset.optionPosition !== String(Number(this.dataset.sizeIndex) + 1)) return;
        const wasCustom = this.isCustom;
        this.isCustom = control.value === this.dataset.customOptionId || control.value === this.dataset.customValue;
        if (this.isCustom && !wasCustom) this.disclosure.open = true;
        this.applyState();
        this.remember();
      }

      validateSubmission(event) {
        if (event.target.getAttribute?.('id') !== this.formId) return;
        const form = event.target;
        const picker = [...document.querySelectorAll('variant-picker')].find(node => node.getAttribute('form-id') === this.formId);
        const variant = picker?.selectedVariant;
        const selectedSize = [...form.elements].find(node => node.dataset.optionPosition === String(Number(this.dataset.sizeIndex) + 1) && node.checked);
        if (selectedSize) this.isCustom = selectedSize.value === this.dataset.customOptionId || selectedSize.value === this.dataset.customValue;
        this.applyState();
        const variantIsCustom = variant?.options?.[Number(this.dataset.sizeIndex)] === this.dataset.customValue;
        if (picker && (!variant?.id || String(variant.id) !== form.elements.namedItem('id')?.value || variantIsCustom !== this.isCustom)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.hidden = false;
          this.disclosure.open = true;
          this.querySelector('[data-fit-updating]').hidden = false;
          return;
        }
        this.querySelector('[data-fit-updating]').hidden = true;
        if (!this.isCustom || this.later.checked) return;
        const invalid = this.measurements.find(field => !field.validity.valid);
        if (!invalid) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.disclosure.open = true;
        invalid.focus();
        invalid.reportValidity();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kk-pheran-measurements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-pheran-measurements')) {
    const sizingDrafts = new Map();
    const currentComponent = (key) => Array.from(document.querySelectorAll('kk-pheran-measurements')).find((node) => node.dataset.instance === key);
    customElements.define('kk-pheran-measurements', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.init(); });
      }
      disconnectedCallback() {
        this.events?.abort();
        this.locks?.forEach((disabled, node) => { if (node.isConnected) node.disabled = disabled; });
        this.hiddenControls?.forEach((node) => node.removeAttribute('data-kk-sizing-hidden'));
      }
      init() {
        this.events?.abort();
        this.events = new AbortController();
        this.locks = new Map();
        this.hiddenControls = [];
        this.toggle = this.querySelector('[data-measurement-toggle]');
        this.fields = this.querySelector('[data-measurement-fields]');
        this.requestInput = this.querySelector('[data-measurement-request]');
        this.specialInput = this.querySelector('[data-special-request]');
        this.specialDetails = this.querySelector('[data-special-details]');
        this.status = this.querySelector('[data-measurement-status]');
        this.form = document.getElementById(this.dataset.form);
        this.picker = Array.from(document.querySelectorAll('variant-picker')).find((node) => node.getAttribute('form-id') === this.dataset.form);
        if (!this.form || !this.picker || typeof this.picker.selectCombination !== 'function' || !this.customControl()) return;
        const selectedSize = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.checked);
        let draft = sizingDrafts.get(this.dataset.instance);
        if (!draft) {
          draft = { mode: selectedSize?.value === this.dataset.customId ? 'custom' : 'standard', lastStandard: selectedSize?.value === this.dataset.customId ? '' : selectedSize?.value, measurements: '', special: '', specialOpen: false, pending: false, error: false };
          sizingDrafts.set(this.dataset.instance, draft);
        }
        this.state = draft;
        this.requestInput.value = draft.measurements;
        this.specialInput.value = draft.special;
        this.specialDetails.open = draft.specialOpen;
        this.querySelector('[data-measurement-toggle-label]').hidden = false;
        const custom = this.customControl();
        this.hideControl(custom);
        Array.from(custom.labels || []).forEach((label) => this.hideControl(label));
        custom.closest('fieldset')?.querySelectorAll('.variant-picker__option-info span').forEach((span) => {
          if (span.textContent.trim() === this.dataset.customValue) this.hideControl(span);
        });
        this.toggle.addEventListener('change', () => this.onToggle(), { signal: this.events.signal });
        this.requestInput.addEventListener('input', () => { draft.measurements = this.requestInput.value; this.validateMeasurements(); }, { signal: this.events.signal });
        this.specialInput.addEventListener('input', () => { draft.special = this.specialInput.value; }, { signal: this.events.signal });
        this.specialDetails.addEventListener('toggle', () => { draft.specialOpen = this.specialDetails.open; }, { signal: this.events.signal });
        document.addEventListener('change', (event) => this.onOptionChange(event), { capture: true, signal: this.events.signal });
        this.form.addEventListener('submit', (event) => this.guardSubmit(event), { capture: true, signal: this.events.signal });
        this.querySelector('[data-measurement-reload]').addEventListener('click', () => window.location.reload(), { signal: this.events.signal });
        this.form.addEventListener('reset', () => queueMicrotask(() => {
          draft.measurements = ''; draft.special = ''; draft.specialOpen = false;
          const active = currentComponent(this.dataset.instance);
          if (active) { active.requestInput.value = ''; active.specialInput.value = ''; active.specialDetails.open = false; active.sync(); }
        }), { signal: this.events.signal });
        this.sync();
      }
      controls() {
        return Array.from(this.form?.elements || []).filter((node) => node.matches('input[data-option-position]'));
      }
      customControl() {
        return this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === this.dataset.customId);
      }
      hideControl(node) {
        node.setAttribute('data-kk-sizing-hidden', '');
        this.hiddenControls.push(node);
      }
      onToggle() {
        if (this.state.pending || this.state.error) { this.sync(); return; }
        if (this.toggle.checked) {
          const standard = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.checked && node.value !== this.dataset.customId);
          if (standard) this.state.lastStandard = standard.value;
          this.state.mode = 'custom';
          this.selectSize(this.dataset.customId);
        } else {
          const previous = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === this.state.lastStandard && !node.disabled);
          this.state.mode = previous ? 'standard' : 'choose';
          if (previous) this.selectSize(previous.value);
          else this.sync();
        }
      }
      onOptionChange(event) {
        const input = event.target;
        if (!input.matches?.('input[data-option-position]') || input.form !== this.form) return;
        event.stopImmediatePropagation();
        if (this.state.pending || this.state.error) return;
        if (input.dataset.optionPosition === this.dataset.sizePosition) {
          this.state.mode = input.value === this.dataset.customId ? 'custom' : 'standard';
          if (this.state.mode === 'standard') this.state.lastStandard = input.value;
        }
        this.selectCombination();
      }
      selectSize(value) {
        const input = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === value);
        if (!input) { this.state.error = true; this.sync(); return; }
        input.checked = true;
        this.selectCombination();
      }
      async selectCombination() {
        const state = this.state;
        const key = this.dataset.instance;
        const optionValues = this.controls().filter((node) => node.checked).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((node) => node.value);
        state.expectedOptions = optionValues.join(',');
        state.pending = true;
        state.error = false;
        this.sync();
        const timer = setTimeout(() => {
          state.error = true;
          currentComponent(key)?.sync();
        }, 15000);
        try {
          await this.picker.selectCombination({ optionValues, productChange: false });
        } catch (error) {
          state.error = true;
        } finally {
          clearTimeout(timer);
          state.pending = false;
          currentComponent(key)?.sync();
        }
      }
      validateMeasurements() {
        this.requestInput.setCustomValidity(this.state.mode === 'custom' && !this.requestInput.value.trim() ? this.dataset.requiredMessage : '');
      }
      selectionMatches() {
        const variant = this.picker.selectedVariant;
        const isCustom = variant?.options?.[Number(this.dataset.sizePosition) - 1] === this.dataset.customValue;
        const variantInput = this.form.elements.namedItem('id');
        const renderedOptions = this.dataset.selectedOptions.split(',').filter(Boolean).join(',');
        const checkedOptions = this.controls().filter((node) => node.checked).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((node) => node.value).join(',');
        const expectedOptions = this.state.expectedOptions || renderedOptions;
        return Boolean(variant?.id && String(variant.id) === variantInput?.value && renderedOptions === expectedOptions && checkedOptions === expectedOptions && (this.state.mode === 'custom' ? isCustom : this.state.mode === 'standard' && !isCustom));
      }
      guardSubmit(event) {
        const blocked = this.state.pending || this.state.error || !this.selectionMatches();
        this.validateMeasurements();
        if (blocked || !this.requestInput.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.sync();
          if (!blocked) this.requestInput.reportValidity();
          else this.status.scrollIntoView({ block: 'nearest' });
        }
      }
      sync() {
        if (!this.state || !this.isConnected) return;
        if (!this.state.pending && this.state.mode !== 'choose' && !this.selectionMatches()) this.state.error = true;
        const custom = this.state.mode === 'custom';
        const locked = this.state.pending || this.state.error;
        this.toggle.checked = custom;
        this.toggle.disabled = locked;
        this.toggle.setAttribute('aria-expanded', String(custom));
        this.fields.hidden = !custom;
        this.fields.disabled = !custom;
        this.requestInput.required = custom;
        this.querySelector('[data-custom-sizing-property]').disabled = !custom;
        this.validateMeasurements();
        const message = this.state.error ? this.dataset.errorMessage : this.state.pending ? this.dataset.loadingMessage : this.state.mode === 'choose' ? this.dataset.chooseMessage : '';
        this.status.textContent = message;
        this.status.hidden = !message;
        this.querySelector('[data-measurement-reload]').hidden = !this.state.error;
        const sizeControls = this.controls();
        const submitButtons = Array.from(this.form.elements).filter((node) => node.type === 'submit');
        const controlsToLock = new Set(locked ? [...sizeControls, ...submitButtons] : this.state.mode === 'choose' ? submitButtons : []);
        for (const [node, disabled] of this.locks) {
          if (!controlsToLock.has(node)) { node.disabled = disabled; this.locks.delete(node); }
        }
        controlsToLock.forEach((node) => {
          if (!this.locks.has(node)) this.locks.set(node, node.disabled);
          node.disabled = true;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kk-pheran-ready-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-pheran-delivery')) {
    customElements.define('kk-pheran-delivery', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.init(); });
      }
      disconnectedCallback() {
        this.events?.abort();
      }
      init() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.updateDates();
        this.addEventListener('input', event => {
          if (event.target.matches('[data-kk-country-search]')) this.filterCountries(event.target);
        }, options);
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-kk-country-code]');
          if (button && this.contains(button)) this.changeCountry(button.dataset.kkCountryCode);
        }, options);
      }
      updateDates() {
        const addDays = (date, days) => {
          const result = new Date(date);
          result.setDate(result.getDate() + days);
          return result;
        };
        const monthDay = date => date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        const dateRange = (start, end) => {
          if (start.getTime() === end.getTime()) return monthDay(start);
          if (start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()) {
            return `${monthDay(start)}–${end.getDate()}`;
          }
          return `${monthDay(start)}–${monthDay(end)}`;
        };
        const dispatchDate = addDays(new Date(), 1);
        const isIndia = this.dataset.countryCode === 'IN';
        const deliveryStart = addDays(dispatchDate, isIndia ? 4 : 10);
        const deliveryEnd = addDays(dispatchDate, isIndia ? 4 : 12);
        this.querySelectorAll('[data-kk-pheran-dispatch]').forEach(element => {
          element.textContent = monthDay(dispatchDate);
        });
        this.querySelectorAll('[data-kk-pheran-delivery]').forEach(element => {
          element.textContent = dateRange(deliveryStart, deliveryEnd);
        });
      }
      filterCountries(input) {
        const query = input.value.toLowerCase().trim();
        const container = input.closest('.kk-location-details');
        let visibleCount = 0;
        container.querySelectorAll('[data-kk-country]').forEach(country => {
          const matches = (country.dataset.search || '').includes(query);
          country.style.display = matches ? 'block' : 'none';
          if (matches) visibleCount += 1;
        });
        const empty = container.querySelector('[data-kk-no-results]');
        if (empty) empty.style.display = visibleCount === 0 ? 'block' : 'none';
      }
      changeCountry(countryCode) {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.delete('country');
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = '/localization';
        form.style.display = 'none';
        const fields = {
          _method: 'put',
          form_type: 'localization',
          country_code: countryCode,
          return_to: currentUrl.pathname + currentUrl.search + currentUrl.hash
        };
        Object.entries(fields).forEach(([name, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          form.appendChild(input);
        });
        document.body.appendChild(form);
        form.submit();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kk-robe-measurements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-robe-measurements')) {
    const sizingDrafts = new Map();
    const currentComponent = (key) => Array.from(document.querySelectorAll('kk-robe-measurements')).find((node) => node.dataset.instance === key);
    customElements.define('kk-robe-measurements', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.init(); });
      }
      disconnectedCallback() {
        this.events?.abort();
        this.locks?.forEach((disabled, node) => { if (node.isConnected) node.disabled = disabled; });
        this.hiddenControls?.forEach((node) => node.removeAttribute('data-kk-sizing-hidden'));
      }
      init() {
        this.events?.abort();
        this.events = new AbortController();
        this.locks = new Map();
        this.hiddenControls = [];
        this.toggle = this.querySelector('[data-measurement-toggle]');
        this.fields = this.querySelector('[data-measurement-fields]');
        this.requestInput = this.querySelector('[data-measurement-request]');
        this.specialInput = this.querySelector('[data-special-request]');
        this.specialDetails = this.querySelector('[data-special-details]');
        this.status = this.querySelector('[data-measurement-status]');
        this.form = document.getElementById(this.dataset.form);
        this.picker = Array.from(document.querySelectorAll('variant-picker')).find((node) => node.getAttribute('form-id') === this.dataset.form);
        if (!this.form || !this.picker || typeof this.picker.selectCombination !== 'function' || !this.customControl()) return;
        const selectedSize = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.checked);
        let draft = sizingDrafts.get(this.dataset.instance);
        if (!draft) {
          draft = { mode: selectedSize?.value === this.dataset.customId ? 'custom' : 'standard', lastStandard: selectedSize?.value === this.dataset.customId ? '' : selectedSize?.value, measurements: '', special: '', specialOpen: false, pending: false, error: false };
          sizingDrafts.set(this.dataset.instance, draft);
        }
        this.state = draft;
        this.requestInput.value = draft.measurements;
        this.specialInput.value = draft.special;
        this.specialDetails.open = draft.specialOpen;
        this.querySelector('[data-measurement-toggle-label]').hidden = false;
        const custom = this.customControl();
        this.hideControl(custom);
        Array.from(custom.labels || []).forEach((label) => this.hideControl(label));
        custom.closest('fieldset')?.querySelectorAll('.variant-picker__option-info span').forEach((span) => {
          if (span.textContent.trim() === this.dataset.customValue) this.hideControl(span);
        });
        this.toggle.addEventListener('change', () => this.onToggle(), { signal: this.events.signal });
        this.requestInput.addEventListener('input', () => { draft.measurements = this.requestInput.value; this.validateMeasurements(); }, { signal: this.events.signal });
        this.specialInput.addEventListener('input', () => { draft.special = this.specialInput.value; }, { signal: this.events.signal });
        this.specialDetails.addEventListener('toggle', () => { draft.specialOpen = this.specialDetails.open; }, { signal: this.events.signal });
        document.addEventListener('change', (event) => this.onOptionChange(event), { capture: true, signal: this.events.signal });
        this.form.addEventListener('submit', (event) => this.guardSubmit(event), { capture: true, signal: this.events.signal });
        this.querySelector('[data-measurement-reload]').addEventListener('click', () => window.location.reload(), { signal: this.events.signal });
        this.form.addEventListener('reset', () => queueMicrotask(() => {
          draft.measurements = ''; draft.special = ''; draft.specialOpen = false;
          const active = currentComponent(this.dataset.instance);
          if (active) { active.requestInput.value = ''; active.specialInput.value = ''; active.specialDetails.open = false; active.sync(); }
        }), { signal: this.events.signal });
        this.sync();
      }
      controls() {
        return Array.from(this.form?.elements || []).filter((node) => node.matches('input[data-option-position]'));
      }
      customControl() {
        return this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === this.dataset.customId);
      }
      hideControl(node) {
        node.setAttribute('data-kk-sizing-hidden', '');
        this.hiddenControls.push(node);
      }
      onToggle() {
        if (this.state.pending || this.state.error) { this.sync(); return; }
        if (this.toggle.checked) {
          const standard = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.checked && node.value !== this.dataset.customId);
          if (standard) this.state.lastStandard = standard.value;
          this.state.mode = 'custom';
          this.selectSize(this.dataset.customId);
        } else {
          const previous = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === this.state.lastStandard && !node.disabled);
          this.state.mode = previous ? 'standard' : 'choose';
          if (previous) this.selectSize(previous.value);
          else this.sync();
        }
      }
      onOptionChange(event) {
        const input = event.target;
        if (!input.matches?.('input[data-option-position]') || input.form !== this.form) return;
        event.stopImmediatePropagation();
        if (this.state.pending || this.state.error) return;
        if (input.dataset.optionPosition === this.dataset.sizePosition) {
          this.state.mode = input.value === this.dataset.customId ? 'custom' : 'standard';
          if (this.state.mode === 'standard') this.state.lastStandard = input.value;
        }
        this.selectCombination();
      }
      selectSize(value) {
        const input = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === value);
        if (!input) { this.state.error = true; this.sync(); return; }
        input.checked = true;
        this.selectCombination();
      }
      async selectCombination() {
        const state = this.state;
        const key = this.dataset.instance;
        const optionValues = this.controls().filter((node) => node.checked).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((node) => node.value);
        state.expectedOptions = optionValues.join(',');
        state.pending = true;
        state.error = false;
        this.sync();
        const timer = setTimeout(() => {
          state.error = true;
          currentComponent(key)?.sync();
        }, 15000);
        try {
          await this.picker.selectCombination({ optionValues, productChange: false });
        } catch (error) {
          state.error = true;
        } finally {
          clearTimeout(timer);
          state.pending = false;
          currentComponent(key)?.sync();
        }
      }
      validateMeasurements() {
        this.requestInput.setCustomValidity(this.state.mode === 'custom' && !this.requestInput.value.trim() ? this.dataset.requiredMessage : '');
      }
      selectionMatches() {
        const variant = this.picker.selectedVariant;
        const isCustom = variant?.options?.[Number(this.dataset.sizePosition) - 1] === this.dataset.customValue;
        const variantInput = this.form.elements.namedItem('id');
        const renderedOptions = this.dataset.selectedOptions.split(',').filter(Boolean).join(',');
        const checkedOptions = this.controls().filter((node) => node.checked).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((node) => node.value).join(',');
        const expectedOptions = this.state.expectedOptions || renderedOptions;
        return Boolean(variant?.id && String(variant.id) === variantInput?.value && renderedOptions === expectedOptions && checkedOptions === expectedOptions && (this.state.mode === 'custom' ? isCustom : this.state.mode === 'standard' && !isCustom));
      }
      guardSubmit(event) {
        const blocked = this.state.pending || this.state.error || !this.selectionMatches();
        this.validateMeasurements();
        if (blocked || !this.requestInput.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.sync();
          if (!blocked) this.requestInput.reportValidity();
          else this.status.scrollIntoView({ block: 'nearest' });
        }
      }
      sync() {
        if (!this.state || !this.isConnected) return;
        if (!this.state.pending && this.state.mode !== 'choose' && !this.selectionMatches()) this.state.error = true;
        const custom = this.state.mode === 'custom';
        const locked = this.state.pending || this.state.error;
        this.toggle.checked = custom;
        this.toggle.disabled = locked;
        this.toggle.setAttribute('aria-expanded', String(custom));
        this.fields.hidden = !custom;
        this.fields.disabled = !custom;
        this.requestInput.required = custom;
        this.querySelector('[data-custom-sizing-property]').disabled = !custom;
        this.validateMeasurements();
        const message = this.state.error ? this.dataset.errorMessage : this.state.pending ? this.dataset.loadingMessage : this.state.mode === 'choose' ? this.dataset.chooseMessage : '';
        this.status.textContent = message;
        this.status.hidden = !message;
        this.querySelector('[data-measurement-reload]').hidden = !this.state.error;
        const sizeControls = this.controls();
        const submitButtons = Array.from(this.form.elements).filter((node) => node.type === 'submit');
        const controlsToLock = new Set(locked ? [...sizeControls, ...submitButtons] : this.state.mode === 'choose' ? submitButtons : []);
        for (const [node, disabled] of this.locks) {
          if (!controlsToLock.has(node)) { node.disabled = disabled; this.locks.delete(node); }
        }
        controlsToLock.forEach((node) => {
          if (!this.locks.has(node)) this.locks.set(node, node.disabled);
          node.disabled = true;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kk-saree-blouse"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-saree-blouse')) {
    const blouseDrafts = new Map();
    customElements.define('kk-saree-blouse', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.init(); });
      }
      disconnectedCallback() {
        this.events?.abort();
      }
      init() {
        this.events?.abort();
        this.events = new AbortController();
        this.notes = this.querySelector('textarea');
        this.form = document.getElementById(this.dataset.form);
        if (!this.notes || !this.form) return;
        this.picker = Array.from(document.querySelectorAll('variant-picker')).find((picker) => picker.getAttribute('form-id') === this.dataset.form);
        this.notes.value = blouseDrafts.get(this.dataset.instance) || '';
        this.notes.addEventListener('input', () => {
          blouseDrafts.set(this.dataset.instance, this.notes.value);
        }, { signal: this.events.signal });
        document.addEventListener('change', (event) => {
          if (event.target.form === this.form && event.target.dataset.optionPosition === this.dataset.optionPosition) this.sync();
        }, { capture: true, signal: this.events.signal });
        document.addEventListener('variant:change', (event) => {
          if (event.detail?.formId === this.dataset.form || event.target === this.form || event.target === this.picker) this.sync(event.detail?.variant);
        }, { signal: this.events.signal });
        this.form.addEventListener('reset', () => {
          blouseDrafts.delete(this.dataset.instance);
          queueMicrotask(() => {
            if (!this.isConnected) return;
            this.notes.value = '';
            this.sync();
          });
        }, { signal: this.events.signal });
        this.sync();
      }
      sync(variant) {
        if (!this.isConnected) return;
        const selected = Array.from(this.form.elements).find((control) => {
          return control.dataset.optionPosition === this.dataset.optionPosition && (control.matches('select') || control.checked);
        });
        const selectedVariant = variant || this.picker?.selectedVariant;
        const custom = selected
          ? selected.value === this.dataset.customId || selected.value === this.dataset.customValue
          : selectedVariant?.options
            ? selectedVariant.options[Number(this.dataset.optionPosition) - 1] === this.dataset.customValue
            : this.dataset.initialCustom === 'true';
        this.hidden = !custom;
        this.notes.disabled = !custom;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kk-saree-measurements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-saree-measurements')) {
    const sizingDrafts = new Map();
    const currentComponent = (key) => Array.from(document.querySelectorAll('kk-saree-measurements')).find((node) => node.dataset.instance === key);
    customElements.define('kk-saree-measurements', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.init(); });
      }
      disconnectedCallback() {
        this.events?.abort();
        this.locks?.forEach((disabled, node) => { if (node.isConnected) node.disabled = disabled; });
        this.hiddenControls?.forEach((node) => node.removeAttribute('data-kk-sizing-hidden'));
      }
      init() {
        this.events?.abort();
        this.events = new AbortController();
        this.locks = new Map();
        this.hiddenControls = [];
        this.toggle = this.querySelector('[data-measurement-toggle]');
        this.fields = this.querySelector('[data-measurement-fields]');
        this.requestInput = this.querySelector('[data-measurement-request]');
        this.specialInput = this.querySelector('[data-special-request]');
        this.specialDetails = this.querySelector('[data-special-details]');
        this.status = this.querySelector('[data-measurement-status]');
        this.form = document.getElementById(this.dataset.form);
        this.picker = Array.from(document.querySelectorAll('variant-picker')).find((node) => node.getAttribute('form-id') === this.dataset.form);
        if (!this.form || !this.picker || typeof this.picker.selectCombination !== 'function' || !this.customControl()) return;
        const selectedSize = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.checked);
        let draft = sizingDrafts.get(this.dataset.instance);
        if (!draft) {
          draft = { mode: selectedSize?.value === this.dataset.customId ? 'custom' : 'standard', lastStandard: selectedSize?.value === this.dataset.customId ? '' : selectedSize?.value, measurements: '', special: '', specialOpen: false, pending: false, error: false };
          sizingDrafts.set(this.dataset.instance, draft);
        }
        this.state = draft;
        this.requestInput.value = draft.measurements;
        this.specialInput.value = draft.special;
        this.specialDetails.open = draft.specialOpen;
        this.querySelector('[data-measurement-toggle-label]').hidden = false;
        const custom = this.customControl();
        this.hideControl(custom);
        Array.from(custom.labels || []).forEach((label) => this.hideControl(label));
        custom.closest('fieldset')?.querySelectorAll('.variant-picker__option-info span').forEach((span) => {
          if (span.textContent.trim() === this.dataset.customValue) this.hideControl(span);
        });
        this.toggle.addEventListener('change', () => this.onToggle(), { signal: this.events.signal });
        this.requestInput.addEventListener('input', () => { draft.measurements = this.requestInput.value; this.validateMeasurements(); }, { signal: this.events.signal });
        this.specialInput.addEventListener('input', () => { draft.special = this.specialInput.value; }, { signal: this.events.signal });
        this.specialDetails.addEventListener('toggle', () => { draft.specialOpen = this.specialDetails.open; }, { signal: this.events.signal });
        document.addEventListener('change', (event) => this.onOptionChange(event), { capture: true, signal: this.events.signal });
        this.form.addEventListener('submit', (event) => this.guardSubmit(event), { capture: true, signal: this.events.signal });
        this.querySelector('[data-measurement-reload]').addEventListener('click', () => window.location.reload(), { signal: this.events.signal });
        this.form.addEventListener('reset', () => queueMicrotask(() => {
          draft.measurements = ''; draft.special = ''; draft.specialOpen = false;
          const active = currentComponent(this.dataset.instance);
          if (active) { active.requestInput.value = ''; active.specialInput.value = ''; active.specialDetails.open = false; active.sync(); }
        }), { signal: this.events.signal });
        this.sync();
      }
      controls() {
        return Array.from(this.form?.elements || []).filter((node) => node.matches('input[data-option-position]'));
      }
      customControl() {
        return this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === this.dataset.customId);
      }
      hideControl(node) {
        node.setAttribute('data-kk-sizing-hidden', '');
        this.hiddenControls.push(node);
      }
      onToggle() {
        if (this.state.pending || this.state.error) { this.sync(); return; }
        if (this.toggle.checked) {
          const standard = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.checked && node.value !== this.dataset.customId);
          if (standard) this.state.lastStandard = standard.value;
          this.state.mode = 'custom';
          this.selectSize(this.dataset.customId);
        } else {
          const previous = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === this.state.lastStandard && !node.disabled);
          this.state.mode = previous ? 'standard' : 'choose';
          if (previous) this.selectSize(previous.value);
          else this.sync();
        }
      }
      onOptionChange(event) {
        const input = event.target;
        if (!input.matches?.('input[data-option-position]') || input.form !== this.form) return;
        event.stopImmediatePropagation();
        if (this.state.pending || this.state.error) return;
        if (input.dataset.optionPosition === this.dataset.sizePosition) {
          this.state.mode = input.value === this.dataset.customId ? 'custom' : 'standard';
          if (this.state.mode === 'standard') this.state.lastStandard = input.value;
        }
        this.selectCombination();
      }
      selectSize(value) {
        const input = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === value);
        if (!input) { this.state.error = true; this.sync(); return; }
        input.checked = true;
        this.selectCombination();
      }
      async selectCombination() {
        const state = this.state;
        const key = this.dataset.instance;
        const optionValues = this.controls().filter((node) => node.checked).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((node) => node.value);
        state.expectedOptions = optionValues.join(',');
        state.pending = true;
        state.error = false;
        this.sync();
        const timer = setTimeout(() => {
          state.error = true;
          currentComponent(key)?.sync();
        }, 15000);
        try {
          await this.picker.selectCombination({ optionValues, productChange: false });
        } catch (error) {
          state.error = true;
        } finally {
          clearTimeout(timer);
          state.pending = false;
          currentComponent(key)?.sync();
        }
      }
      validateMeasurements() {
        this.requestInput.setCustomValidity(this.state.mode === 'custom' && !this.requestInput.value.trim() ? this.dataset.requiredMessage : '');
      }
      selectionMatches() {
        const variant = this.picker.selectedVariant;
        const isCustom = variant?.options?.[Number(this.dataset.sizePosition) - 1] === this.dataset.customValue;
        const variantInput = this.form.elements.namedItem('id');
        const renderedOptions = this.dataset.selectedOptions.split(',').filter(Boolean).join(',');
        const checkedOptions = this.controls().filter((node) => node.checked).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((node) => node.value).join(',');
        const expectedOptions = this.state.expectedOptions || renderedOptions;
        return Boolean(variant?.id && String(variant.id) === variantInput?.value && renderedOptions === expectedOptions && checkedOptions === expectedOptions && (this.state.mode === 'custom' ? isCustom : this.state.mode === 'standard' && !isCustom));
      }
      guardSubmit(event) {
        const blocked = this.state.pending || this.state.error || !this.selectionMatches();
        this.validateMeasurements();
        if (blocked || !this.requestInput.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.sync();
          if (!blocked) this.requestInput.reportValidity();
          else this.status.scrollIntoView({ block: 'nearest' });
        }
      }
      sync() {
        if (!this.state || !this.isConnected) return;
        if (!this.state.pending && this.state.mode !== 'choose' && !this.selectionMatches()) this.state.error = true;
        const custom = this.state.mode === 'custom';
        const locked = this.state.pending || this.state.error;
        this.toggle.checked = custom;
        this.toggle.disabled = locked;
        this.toggle.setAttribute('aria-expanded', String(custom));
        this.fields.hidden = !custom;
        this.fields.disabled = !custom;
        this.requestInput.required = custom;
        this.querySelector('[data-custom-sizing-property]').disabled = !custom;
        this.validateMeasurements();
        const message = this.state.error ? this.dataset.errorMessage : this.state.pending ? this.dataset.loadingMessage : this.state.mode === 'choose' ? this.dataset.chooseMessage : '';
        this.status.textContent = message;
        this.status.hidden = !message;
        this.querySelector('[data-measurement-reload]').hidden = !this.state.error;
        const sizeControls = this.controls();
        const submitButtons = Array.from(this.form.elements).filter((node) => node.type === 'submit');
        const controlsToLock = new Set(locked ? [...sizeControls, ...submitButtons] : this.state.mode === 'choose' ? submitButtons : []);
        for (const [node, disabled] of this.locks) {
          if (!controlsToLock.has(node)) { node.disabled = disabled; this.locks.delete(node); }
        }
        controlsToLock.forEach((node) => {
          if (!this.locks.has(node)) this.locks.set(node, node.disabled);
          node.disabled = true;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kk-site-texture"] && !Shopify.designMode) return;
  try {
    (() => {
    const ns = 'http://www.w3.org/2000/svg';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = window.matchMedia('(min-width: 700px)');
    const targets = new Set();
    const visible = new Set();
    const cycleStart = document.timeline.currentTime || 0;
    const stems = [
      ['M12 76C31 70 40 59 49 42C55 31 63 21 76 12', ''],
      ['M30 66C19 65 15 57 17 49C26 49 33 55 30 66Z', 'leaf'],
      ['M34 61L19 52', ''],
      ['M40 53C50 55 58 49 59 42C50 40 42 44 40 53Z', 'leaf'],
      ['M43 50L55 44', ''],
      ['M53 35C44 34 41 26 44 19C53 20 56 27 53 35Z', 'leaf'],
      ['M54 31L46 23', ''],
      ['M61 24C69 29 79 25 83 18C75 14 66 16 61 24Z', 'leaf'],
      ['M65 23L78 19', '']
    ];
    const flower = [
      ['M31 49C25 43 24 37 30 33C36 35 37 42 31 49Z', 'petal'],
      ['M31 49C34 41 39 37 45 41C45 48 38 52 31 49Z', 'petal'],
      ['M31 49C38 52 40 58 35 63C28 61 27 55 31 49Z', 'petal'],
      ['M31 49C25 54 18 52 17 45C23 41 28 43 31 49Z', 'petal'],
      ['M28 49A3 3 0 1 0 34 49A3 3 0 1 0 28 49', ''],
      ['M70 15C67 9 71 4 76 6C81 9 77 14 74 16', 'petal']
    ];
    const paisley = [
      ['M27 57C10 53 9 34 20 25C29 18 39 27 34 35C29 41 23 36 27 32C18 34 17 44 24 47C35 51 42 39 37 26C50 38 44 58 27 57Z', 'petal'],
      ['M26 52C17 47 15 39 20 33', ''],
      ['M28 25C36 19 42 15 43 8', ''],
      ['M43 9C36 11 34 16 38 19C44 18 47 13 43 9Z', 'leaf']
    ];


    const sync = svg => {
      const running = !document.hidden && !reduced.matches && visible.has(svg);
      svg.classList.toggle('is-paused', !running);
      if (running) {
        // Rejoin the shared clock after scrolling into view or resuming the tab.
        svg.getAnimations({ subtree: true }).forEach(animation => {
          if (animation.animationName === 'kk-motif-cycle') animation.startTime = cycleStart;
        });
      }
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!targets.has(entry.target)) return;
        if (entry.isIntersecting && entry.intersectionRatio >= .2) visible.add(entry.target);
        else visible.delete(entry.target);
        sync(entry.target);
      });
    }, { threshold: [0, .2] }) : null;

    const forget = svg => {
      observer?.unobserve(svg);
      targets.delete(svg);
      visible.delete(svg);
    };
    const add = (host, kind, shape, slot) => {
      if (!host || [...host.querySelectorAll(':scope > .kk-motif')].some(svg => svg.dataset.motifSlot === slot)) return;
      const svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('viewBox', '0 0 96 84');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      svg.dataset.motifSlot = slot;
      svg.classList.add('kk-motif', ...kind.split(' '));
      [...stems, ...(shape === 'paisley' ? paisley : flower)].forEach(([d, tone], i) => {
        const path = document.createElementNS(ns, 'path');
        path.setAttribute('d', d);
        path.setAttribute('pathLength', '1');
        if (tone) path.classList.add('kk-motif__' + tone);
        path.style.setProperty('--stitch-delay', Math.min(i * .08, .96) + 's');
        svg.append(path);
      });
      host.classList.add('kk-motif-host');
      host.append(svg);
      if (observer) {
        targets.add(svg);
        svg.classList.add('is-looping', 'is-paused');
        observer.observe(svg);
      }
    };

    const decorateSharedAreas = () => {
      const main = document.getElementById('main');
      if (!main) return;
      const footerGroup = main.querySelector('.shopify-section-group-footer-group');
      if (footerGroup) {
        let band = main.querySelector(':scope > .kk-motif-band');
        if (!band) {
          band = document.createElement('div');
          band.className = 'kk-motif-band';
          band.setAttribute('aria-hidden', 'true');
          main.insertBefore(band, footerGroup);
        }
        if (band.nextElementSibling !== footerGroup) main.insertBefore(band, footerGroup);
        add(band, 'kk-motif--band kk-motif--start', 'flower', 'band-start');
        add(band, 'kk-motif--band', 'paisley', 'band-end');
      }
      const footer = main.querySelector('.footer');
      add(footer, 'kk-motif--site-footer', 'paisley', 'site-footer-top');
      add(footer, 'kk-motif--site-footer kk-motif--start kk-motif--lower', 'flower', 'site-footer-bottom');

      // Give plain page titles their own ornament space rather than overlaying text.
      main.querySelectorAll('.collection-header h1, .shopify-section--main-page h1, .shopify-policy__title, .cart-header h1, .search-banner > h1, .blog-banner-content h1, .shopify-section--main-search .empty-state h1, .shopify-section--main-list-collections h1').forEach(title => {
        if (title.closest('.content-over-media, .product-info')) return;
        title.classList.add('kk-motif-title');
        add(title, 'kk-motif--title', 'flower', 'page-title');
      });

      // Other theme sections receive accents only in generous, existing margins.
      main.querySelectorAll('.kk-motif[data-motif-slot^="shared-section-"]').forEach(svg => {
        const host = svg.parentElement;
        const style = getComputedStyle(host);
        const padding = svg.dataset.motifSlot.endsWith('top') ? style.paddingTop : style.paddingBottom;
        if (Number.parseFloat(padding) < 48 || host.getBoundingClientRect().height < 180) {
          forget(svg);
          svg.remove();
          if (!host.querySelector(':scope > .kk-motif')) host.classList.remove('kk-motif-host');
        }
      });
      let count = new Set([...main.querySelectorAll('.kk-motif[data-motif-slot^="shared-section-"]')].map(svg => svg.parentElement)).size;
      main.querySelectorAll(':scope > .shopify-section:not(.shopify-section-group-footer-group) > .section').forEach(section => {
        if (count >= 3 || section.querySelector('.kk-motif, .product-info, .content-over-media, .slideshow, .product-list, .collection, form')) return;
        const style = getComputedStyle(section);
        if (section.getBoundingClientRect().height < 180) return;
        const top = Number.parseFloat(style.paddingTop) >= 48;
        const bottom = Number.parseFloat(style.paddingBottom) >= 48;
        if (!top && !bottom) return;
        if (top) add(section, 'kk-motif--editorial', 'flower', 'shared-section-top');
        if (bottom) add(section, 'kk-motif--editorial kk-motif--start kk-motif--lower kk-motif--small', 'paisley', 'shared-section-bottom');
        count += 1;
      });
    };

    const decorateProductAreas = () => {
      const main = document.getElementById('main');
      const productSection = main?.querySelector('.shopify-section--main-product');
      if (!productSection) return;
      const selected = [];
      const sectionCounts = new Map();
      const height = desktop.matches ? 30 : 20;
      const inset = desktop.matches ? 6 : 5;
      const existing = [...main.querySelectorAll('.kk-motif:not(.kk-motif--product)')];

      // Only use measured outer padding; never place ornaments within buying,
      // certificate, photograph, film, craft-animation or review-widget content.
      const choose = (host, edge, side, allowPair = false) => {
        if (!host || selected.length >= 5) return;
        const section = host.closest('.shopify-section');
        const count = sectionCounts.get(section) || 0;
        if (count >= (allowPair ? 2 : 1)) return;
        const rect = host.getBoundingClientRect();
        const style = getComputedStyle(host);
        const padding = Number.parseFloat(edge === 'top' ? style.paddingTop : style.paddingBottom);
        if (rect.width < 220 || rect.height < 100 || padding < height + inset * 2) return;
        const y = edge === 'top' ? rect.top + inset : rect.bottom - inset - height;
        // Avoid an already decorated margin, including ornaments on nested hosts.
        if (existing.some(svg => {
          if (svg.closest('.shopify-section') !== section) return false;
          const ornament = svg.getBoundingClientRect();
          return ornament.height > 0 && ornament.bottom > y - 5 && ornament.top < y + height + 5;
        })) return;
        const slot = 'product-' + edge + '-' + side;
        if (selected.some(item => item.host === host && item.slot === slot)) return;
        selected.push({ host, edge, side, slot });
        sectionCounts.set(section, count + 1);
      };
      const pick = (selector, edge, side, allowPair = false) => {
        main.querySelectorAll(selector).forEach(host => choose(host, edge, side, allowPair));
      };

      pick('.kk-sj, .kk-msj, .kk-hjm, .kk-cj, .kk-rug-story__inner, .kk-bedcover-story__inner, .kk-cushion-story__inner, .kk-walnut-story__inner', 'top', 'end');
      pick('.kk-oi, .kk-aari-film--included, .kk-psozni, .kk-machine-shawl-craft, .kk-bag-craft, .kk-papier-making, .kk-carpet-story', 'bottom', 'start');
      pick('.kk-sa, .kk-msa', 'top', 'end');
      pick('[id$="__timeline_qc7NQW"] > .section', 'bottom', 'start');
      // This margin exists before asynchronously loaded recommendations arrive.
      pick('.shopify-section--product-recommendations > .section', 'bottom', 'end');

      // Template-specific alternatives keep pages without artisan/order films balanced.
      if (selected.length < 4) {
        main.querySelectorAll('.kk-fabric-guide').forEach(guide => {
          const section = guide.closest('.shopify-section');
          choose(section?.querySelector(':scope > .section') || guide, 'bottom', 'start');
        });
        pick('[id$="__multi_column_TRmUKn"] > .section', 'top', 'end');
        pick('[id$="__multiple_images_with_text_KTwWxU"] > .section', 'bottom', 'end');
      }
      if (selected.length < 4) {
        pick('.kk-sj, .kk-msj, .kk-hjm, .kk-cj, .kk-rug-story__inner, .kk-bedcover-story__inner, .kk-cushion-story__inner, .kk-walnut-story__inner', 'bottom', 'start', true);
        pick('[id$="__rich_text_KeEDwD"] > .section', 'top', 'end');
      }
      if (selected.length < 3) {
        const outer = productSection.querySelector(':scope > .section');
        choose(outer, 'bottom', 'start');
        // Minimal default/pre-order layouts have no storytelling sections.
        if (selected.length < 2) choose(outer, 'bottom', 'end', true);
      }

      main.querySelectorAll('.kk-motif--product').forEach(svg => {
        if (selected.some(item => item.host === svg.parentElement && item.slot === svg.dataset.motifSlot)) return;
        const host = svg.parentElement;
        forget(svg);
        svg.remove();
        if (!host.querySelector(':scope > .kk-motif')) host.classList.remove('kk-motif-host');
      });
      selected.forEach(({ host, edge, side, slot }) => {
        const kind = 'kk-motif--product' + (side === 'start' ? ' kk-motif--start' : '') + (edge === 'bottom' ? ' kk-motif--lower' : '');
        add(host, kind, side === 'start' ? 'paisley' : 'flower', slot);
      });
    };

    const init = () => {
      targets.forEach(svg => { if (!svg.isConnected) forget(svg); });
      document.querySelectorAll('.kk-refined-collection .section-header').forEach((host, i) => {
        add(host, 'kk-motif--heading', i % 2 === 0 ? 'flower' : 'paisley', 'heading-end');
      });
      document.querySelectorAll('.kk-refined-collection__footer').forEach((host, i) => {
        if (i % 2 === 0) add(host, 'kk-motif--footer', 'paisley', 'footer-start');
        else add(host, 'kk-motif--footer kk-motif--end', 'flower', 'footer-end');
        if (i === 0) add(host, 'kk-motif--footer kk-motif--end', 'flower', 'footer-end');
      });
      const family = document.querySelector('[id$="__kk_v2_family_heading"] .section');
      add(family, 'kk-motif--chapter', 'paisley', 'chapter-end');
      add(family, 'kk-motif--chapter kk-motif--start kk-motif--small', 'flower', 'chapter-start');
      const assistance = document.querySelector('.kk-home-assistance');
      add(assistance, 'kk-motif--corner', 'flower', 'corner-end');
      add(assistance, 'kk-motif--corner kk-motif--start kk-motif--lower kk-motif--desktop', 'paisley', 'lower-start');
      const gift = document.querySelector('.kk-home-gift__panel');
      add(gift, 'kk-motif--corner kk-motif--desktop', 'paisley', 'corner-end');
      add(gift, 'kk-motif--corner kk-motif--start kk-motif--lower kk-motif--desktop', 'flower', 'lower-start');
      add(document.querySelector('.kk-pashmina-film-section'), 'kk-motif--spacer kk-motif--start', 'flower', 'spacer-start');
      add(document.querySelector('.kk-home-gift-section'), 'kk-motif--spacer', 'paisley', 'spacer-end');
      add(document.querySelector('.kk-home-reviews-section'), 'kk-motif--spacer kk-motif--start', 'flower', 'spacer-start');
      add(document.querySelector('.kk-pashmina-campaign__hero'), 'kk-motif--corner', 'paisley', 'corner-end');
      add(document.querySelector('.kk-pashmina-collection-grid__heading'), 'kk-motif--heading', 'flower', 'heading-end');
      document.querySelectorAll('.kk-pstory, .kk-plux, .kk-pmaterial, .kk-pmake, .kk-papier-story, .kk-ge').forEach((editorial, i) => {
        if (i > 4) return;
        const style = getComputedStyle(editorial);
        if (Number.parseFloat(style.paddingTop) >= 42) {
          add(editorial, 'kk-motif--editorial' + (i % 2 ? ' kk-motif--start' : ''), i % 2 ? 'paisley' : 'flower', 'editorial-top');
        }
        if (Number.parseFloat(style.paddingBottom) >= 42 && editorial.getBoundingClientRect().height >= 300) {
          add(editorial, 'kk-motif--editorial kk-motif--lower kk-motif--small' + (i % 2 ? '' : ' kk-motif--start'), i % 2 ? 'flower' : 'paisley', 'editorial-bottom');
        }
      });
      decorateSharedAreas();
      decorateProductAreas();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', event => {
      targets.forEach(svg => { if (event.target.contains(svg)) forget(svg); });
    });
    document.addEventListener('visibilitychange', () => targets.forEach(sync));
    reduced.addEventListener('change', () => targets.forEach(sync));
    desktop.addEventListener('change', init);
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(init, 150);
    }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kk-sozni-suit-measurements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-sozni-suit-measurements')) {
    const sizingDrafts = new Map();
    const currentComponent = (key) => Array.from(document.querySelectorAll('kk-sozni-suit-measurements')).find((node) => node.dataset.instance === key);
    customElements.define('kk-sozni-suit-measurements', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.init(); });
      }
      disconnectedCallback() {
        this.events?.abort();
        this.locks?.forEach((disabled, node) => { if (node.isConnected) node.disabled = disabled; });
        this.hiddenControls?.forEach((node) => node.removeAttribute('data-kk-sizing-hidden'));
      }
      init() {
        this.events?.abort();
        this.events = new AbortController();
        this.locks = new Map();
        this.hiddenControls = [];
        this.toggle = this.querySelector('[data-measurement-toggle]');
        this.fields = this.querySelector('[data-measurement-fields]');
        this.requestInput = this.querySelector('[data-measurement-request]');
        this.specialInput = this.querySelector('[data-special-request]');
        this.specialDetails = this.querySelector('[data-special-details]');
        this.status = this.querySelector('[data-measurement-status]');
        this.form = document.getElementById(this.dataset.form);
        this.picker = Array.from(document.querySelectorAll('variant-picker')).find((node) => node.getAttribute('form-id') === this.dataset.form);
        if (!this.form || !this.picker || typeof this.picker.selectCombination !== 'function' || !this.customControl()) return;
        const selectedSize = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.checked);
        let draft = sizingDrafts.get(this.dataset.instance);
        if (!draft) {
          draft = { mode: selectedSize?.value === this.dataset.customId ? 'custom' : 'standard', lastStandard: selectedSize?.value === this.dataset.customId ? '' : selectedSize?.value, measurements: '', special: '', specialOpen: false, pending: false, error: false };
          sizingDrafts.set(this.dataset.instance, draft);
        }
        this.state = draft;
        this.requestInput.value = draft.measurements;
        this.specialInput.value = draft.special;
        this.specialDetails.open = draft.specialOpen;
        this.querySelector('[data-measurement-toggle-label]').hidden = false;
        const custom = this.customControl();
        this.hideControl(custom);
        Array.from(custom.labels || []).forEach((label) => this.hideControl(label));
        custom.closest('fieldset')?.querySelectorAll('.variant-picker__option-info span').forEach((span) => {
          if (span.textContent.trim() === this.dataset.customValue) this.hideControl(span);
        });
        this.toggle.addEventListener('change', () => this.onToggle(), { signal: this.events.signal });
        this.requestInput.addEventListener('input', () => { draft.measurements = this.requestInput.value; this.validateMeasurements(); }, { signal: this.events.signal });
        this.specialInput.addEventListener('input', () => { draft.special = this.specialInput.value; }, { signal: this.events.signal });
        this.specialDetails.addEventListener('toggle', () => { draft.specialOpen = this.specialDetails.open; }, { signal: this.events.signal });
        document.addEventListener('change', (event) => this.onOptionChange(event), { capture: true, signal: this.events.signal });
        this.form.addEventListener('submit', (event) => this.guardSubmit(event), { capture: true, signal: this.events.signal });
        this.querySelector('[data-measurement-reload]').addEventListener('click', () => window.location.reload(), { signal: this.events.signal });
        this.form.addEventListener('reset', () => queueMicrotask(() => {
          draft.measurements = ''; draft.special = ''; draft.specialOpen = false;
          const active = currentComponent(this.dataset.instance);
          if (active) { active.requestInput.value = ''; active.specialInput.value = ''; active.specialDetails.open = false; active.sync(); }
        }), { signal: this.events.signal });
        this.sync();
      }
      controls() {
        return Array.from(this.form?.elements || []).filter((node) => node.matches('input[data-option-position]'));
      }
      customControl() {
        return this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === this.dataset.customId);
      }
      hideControl(node) {
        node.setAttribute('data-kk-sizing-hidden', '');
        this.hiddenControls.push(node);
      }
      onToggle() {
        if (this.state.pending || this.state.error) { this.sync(); return; }
        if (this.toggle.checked) {
          const standard = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.checked && node.value !== this.dataset.customId);
          if (standard) this.state.lastStandard = standard.value;
          this.state.mode = 'custom';
          this.selectSize(this.dataset.customId);
        } else {
          const previous = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === this.state.lastStandard && !node.disabled);
          this.state.mode = previous ? 'standard' : 'choose';
          if (previous) this.selectSize(previous.value);
          else this.sync();
        }
      }
      onOptionChange(event) {
        const input = event.target;
        if (!input.matches?.('input[data-option-position]') || input.form !== this.form) return;
        event.stopImmediatePropagation();
        if (this.state.pending || this.state.error) return;
        if (input.dataset.optionPosition === this.dataset.sizePosition) {
          this.state.mode = input.value === this.dataset.customId ? 'custom' : 'standard';
          if (this.state.mode === 'standard') this.state.lastStandard = input.value;
        }
        this.selectCombination();
      }
      selectSize(value) {
        const input = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === value);
        if (!input) { this.state.error = true; this.sync(); return; }
        input.checked = true;
        this.selectCombination();
      }
      async selectCombination() {
        const state = this.state;
        const key = this.dataset.instance;
        const optionValues = this.controls().filter((node) => node.checked).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((node) => node.value);
        state.expectedOptions = optionValues.join(',');
        state.pending = true;
        state.error = false;
        this.sync();
        const timer = setTimeout(() => {
          state.error = true;
          currentComponent(key)?.sync();
        }, 15000);
        try {
          await this.picker.selectCombination({ optionValues, productChange: false });
        } catch (error) {
          state.error = true;
        } finally {
          clearTimeout(timer);
          state.pending = false;
          currentComponent(key)?.sync();
        }
      }
      validateMeasurements() {
        this.requestInput.setCustomValidity(this.state.mode === 'custom' && !this.requestInput.value.trim() ? this.dataset.requiredMessage : '');
      }
      selectionMatches() {
        const variant = this.picker.selectedVariant;
        const isCustom = variant?.options?.[Number(this.dataset.sizePosition) - 1] === this.dataset.customValue;
        const variantInput = this.form.elements.namedItem('id');
        const renderedOptions = this.dataset.selectedOptions.split(',').filter(Boolean).join(',');
        const checkedOptions = this.controls().filter((node) => node.checked).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((node) => node.value).join(',');
        const expectedOptions = this.state.expectedOptions || renderedOptions;
        return Boolean(variant?.id && String(variant.id) === variantInput?.value && renderedOptions === expectedOptions && checkedOptions === expectedOptions && (this.state.mode === 'custom' ? isCustom : this.state.mode === 'standard' && !isCustom));
      }
      guardSubmit(event) {
        const blocked = this.state.pending || this.state.error || !this.selectionMatches();
        this.validateMeasurements();
        if (blocked || !this.requestInput.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.sync();
          if (!blocked) this.requestInput.reportValidity();
          else this.status.scrollIntoView({ block: 'nearest' });
        }
      }
      sync() {
        if (!this.state || !this.isConnected) return;
        if (!this.state.pending && this.state.mode !== 'choose' && !this.selectionMatches()) this.state.error = true;
        const custom = this.state.mode === 'custom';
        const locked = this.state.pending || this.state.error;
        this.toggle.checked = custom;
        this.toggle.disabled = locked;
        this.toggle.setAttribute('aria-expanded', String(custom));
        this.fields.hidden = !custom;
        this.fields.disabled = !custom;
        this.requestInput.required = custom;
        this.querySelector('[data-custom-sizing-property]').disabled = !custom;
        this.validateMeasurements();
        const message = this.state.error ? this.dataset.errorMessage : this.state.pending ? this.dataset.loadingMessage : this.state.mode === 'choose' ? this.dataset.chooseMessage : '';
        this.status.textContent = message;
        this.status.hidden = !message;
        this.querySelector('[data-measurement-reload]').hidden = !this.state.error;
        const sizeControls = this.controls();
        const submitButtons = Array.from(this.form.elements).filter((node) => node.type === 'submit');
        const controlsToLock = new Set(locked ? [...sizeControls, ...submitButtons] : this.state.mode === 'choose' ? submitButtons : []);
        for (const [node, disabled] of this.locks) {
          if (!controlsToLock.has(node)) { node.disabled = disabled; this.locks.delete(node); }
        }
        controlsToLock.forEach((node) => {
          if (!this.locks.has(node)) this.locks.set(node, node.disabled);
          node.disabled = true;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kk-suit-measurements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-suit-measurements')) {
    const sizingDrafts = new Map();
    const currentComponent = (key) => Array.from(document.querySelectorAll('kk-suit-measurements')).find((node) => node.dataset.instance === key);
    customElements.define('kk-suit-measurements', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.init(); });
      }
      disconnectedCallback() {
        this.events?.abort();
        this.locks?.forEach((disabled, node) => { if (node.isConnected) node.disabled = disabled; });
        this.hiddenControls?.forEach((node) => node.removeAttribute('data-kk-sizing-hidden'));
      }
      init() {
        this.events?.abort();
        this.events = new AbortController();
        this.locks = new Map();
        this.hiddenControls = [];
        this.toggle = this.querySelector('[data-measurement-toggle]');
        this.fields = this.querySelector('[data-measurement-fields]');
        this.requestInput = this.querySelector('[data-measurement-request]');
        this.specialInput = this.querySelector('[data-special-request]');
        this.specialDetails = this.querySelector('[data-special-details]');
        this.status = this.querySelector('[data-measurement-status]');
        this.form = document.getElementById(this.dataset.form);
        this.picker = Array.from(document.querySelectorAll('variant-picker')).find((node) => node.getAttribute('form-id') === this.dataset.form);
        if (!this.form) return;
        const selectedSize = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.checked);
        const renderedCustom = this.dataset.customSelected === 'true';
        let draft = sizingDrafts.get(this.dataset.instance);
        if (!draft) {
          draft = { mode: renderedCustom ? 'custom' : 'standard', lastStandard: selectedSize?.value === this.dataset.customId ? '' : selectedSize?.value, measurements: '', special: '', specialOpen: false, pending: false, error: false };
          sizingDrafts.set(this.dataset.instance, draft);
        }
        this.state = draft;
        this.requestInput.value = draft.measurements;
        this.specialInput.value = draft.special;
        this.specialDetails.open = draft.specialOpen;
        this.enhanced = Boolean(this.picker && typeof this.picker.selectCombination === 'function' && this.customControl());
        this.requestInput.addEventListener('input', () => { draft.measurements = this.requestInput.value; this.validateMeasurements(); }, { signal: this.events.signal });
        this.specialInput.addEventListener('input', () => { draft.special = this.specialInput.value; }, { signal: this.events.signal });
        this.specialDetails.addEventListener('toggle', () => { draft.specialOpen = this.specialDetails.open; }, { signal: this.events.signal });
        this.form.addEventListener('reset', () => queueMicrotask(() => {
          draft.measurements = ''; draft.special = ''; draft.specialOpen = false;
          const active = currentComponent(this.dataset.instance);
          if (active) {
            active.requestInput.value = ''; active.specialInput.value = ''; active.specialDetails.open = false;
            if (active.enhanced) active.sync();
            else active.validateMeasurements();
          }
        }), { signal: this.events.signal });
        if (!this.enhanced) {
          draft.mode = renderedCustom ? 'custom' : 'standard';
          this.fields.hidden = !renderedCustom;
          this.fields.disabled = !renderedCustom;
          this.requestInput.required = renderedCustom;
          this.querySelector('[data-custom-sizing-property]').disabled = !renderedCustom;
          this.validateMeasurements();
          return;
        }
        this.querySelector('[data-measurement-toggle-label]').hidden = false;
        const custom = this.customControl();
        this.hideControl(custom);
        Array.from(custom.labels || []).forEach((label) => this.hideControl(label));
        custom.closest('fieldset')?.querySelectorAll('.variant-picker__option-info span').forEach((span) => {
          if (span.textContent.trim() === this.dataset.customValue) this.hideControl(span);
        });
        this.toggle.addEventListener('change', () => this.onToggle(), { signal: this.events.signal });
        document.addEventListener('change', (event) => this.onOptionChange(event), { capture: true, signal: this.events.signal });
        this.form.addEventListener('submit', (event) => this.guardSubmit(event), { capture: true, signal: this.events.signal });
        this.querySelector('[data-measurement-reload]').addEventListener('click', () => window.location.reload(), { signal: this.events.signal });
        this.sync();
      }
      controls() {
        return Array.from(this.form?.elements || []).filter((node) => node.matches('input[data-option-position]'));
      }
      customControl() {
        return this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === this.dataset.customId);
      }
      hideControl(node) {
        node.setAttribute('data-kk-sizing-hidden', '');
        this.hiddenControls.push(node);
      }
      onToggle() {
        if (this.state.pending || this.state.error) { this.sync(); return; }
        if (this.toggle.checked) {
          const standard = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.checked && node.value !== this.dataset.customId);
          if (standard) this.state.lastStandard = standard.value;
          this.state.mode = 'custom';
          this.selectSize(this.dataset.customId);
        } else {
          const previous = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === this.state.lastStandard && !node.disabled);
          this.state.mode = previous ? 'standard' : 'choose';
          if (previous) this.selectSize(previous.value);
          else this.sync();
        }
      }
      onOptionChange(event) {
        const input = event.target;
        if (!input.matches?.('input[data-option-position]') || input.form !== this.form) return;
        event.stopImmediatePropagation();
        if (this.state.pending || this.state.error) return;
        if (input.dataset.optionPosition === this.dataset.sizePosition) {
          this.state.mode = input.value === this.dataset.customId ? 'custom' : 'standard';
          if (this.state.mode === 'standard') this.state.lastStandard = input.value;
        }
        this.selectCombination();
      }
      selectSize(value) {
        const input = this.controls().find((node) => node.dataset.optionPosition === this.dataset.sizePosition && node.value === value);
        if (!input) { this.state.error = true; this.sync(); return; }
        input.checked = true;
        this.selectCombination();
      }
      async selectCombination() {
        const state = this.state;
        const key = this.dataset.instance;
        const optionValues = this.controls().filter((node) => node.checked).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((node) => node.value);
        state.expectedOptions = optionValues.join(',');
        state.pending = true;
        state.error = false;
        this.sync();
        const timer = setTimeout(() => {
          state.error = true;
          currentComponent(key)?.sync();
        }, 15000);
        try {
          await this.picker.selectCombination({ optionValues, productChange: false });
        } catch (error) {
          state.error = true;
        } finally {
          clearTimeout(timer);
          state.pending = false;
          currentComponent(key)?.sync();
        }
      }
      validateMeasurements() {
        this.requestInput.setCustomValidity(this.state.mode === 'custom' && !this.requestInput.value.trim() ? this.dataset.requiredMessage : '');
      }
      selectionMatches() {
        const variant = this.picker.selectedVariant;
        const isCustom = variant?.options?.[Number(this.dataset.sizePosition) - 1] === this.dataset.customValue;
        const variantInput = this.form.elements.namedItem('id');
        const renderedOptions = this.dataset.selectedOptions.split(',').filter(Boolean).join(',');
        const checkedOptions = this.controls().filter((node) => node.checked).sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((node) => node.value).join(',');
        const expectedOptions = this.state.expectedOptions || renderedOptions;
        return Boolean(variant?.id && String(variant.id) === variantInput?.value && renderedOptions === expectedOptions && checkedOptions === expectedOptions && (this.state.mode === 'custom' ? isCustom : this.state.mode === 'standard' && !isCustom));
      }
      guardSubmit(event) {
        const blocked = this.state.pending || this.state.error || !this.selectionMatches();
        this.validateMeasurements();
        if (blocked || !this.requestInput.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.sync();
          if (!blocked) this.requestInput.reportValidity();
          else this.status.scrollIntoView({ block: 'nearest' });
        }
      }
      sync() {
        if (!this.state || !this.isConnected) return;
        if (!this.state.pending && this.state.mode !== 'choose' && !this.selectionMatches()) this.state.error = true;
        const custom = this.state.mode === 'custom';
        const locked = this.state.pending || this.state.error;
        this.toggle.checked = custom;
        this.toggle.disabled = locked;
        this.toggle.setAttribute('aria-expanded', String(custom));
        this.fields.hidden = !custom;
        this.fields.disabled = !custom;
        this.requestInput.required = custom;
        this.querySelector('[data-custom-sizing-property]').disabled = !custom;
        this.validateMeasurements();
        const message = this.state.error ? this.dataset.errorMessage : this.state.pending ? this.dataset.loadingMessage : this.state.mode === 'choose' ? this.dataset.chooseMessage : '';
        this.status.textContent = message;
        this.status.hidden = !message;
        this.querySelector('[data-measurement-reload]').hidden = !this.state.error;
        const sizeControls = this.controls();
        const submitButtons = Array.from(this.form.elements).filter((node) => node.type === 'submit');
        const controlsToLock = new Set(locked ? [...sizeControls, ...submitButtons] : this.state.mode === 'choose' ? submitButtons : []);
        for (const [node, disabled] of this.locks) {
          if (!controlsToLock.has(node)) { node.disabled = disabled; this.locks.delete(node); }
        }
        controlsToLock.forEach((node) => {
          if (!this.locks.has(node)) this.locks.set(node, node.disabled);
          node.disabled = true;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kk-walnut-carving-animation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-walnut-carving')) {
    customElements.define('kk-walnut-carving', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = true;
        this.motionQuery.addEventListener('change', () => this.sync(), options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            this.sync();
          }, { threshold: 0.1 });
          this.observer.observe(this);
        }
        this.sync();
      }
      sync() {
        const playing = !this.motionQuery.matches && this.visible && !document.hidden;
        this.toggleAttribute('data-playing', playing);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abortController?.abort();
        this.abortController = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-currency-selector')) {
    customElements.define('kk-currency-selector', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.search = this.querySelector('input[type="search"]');
        const listbox = this.querySelector('x-listbox');
        const unpinned = Array.from(listbox.querySelectorAll('[data-priority="false"]'));
        unpinned.sort((a, b) => a.dataset.kkDisplayCurrency.localeCompare(b.dataset.kkDisplayCurrency) || a.textContent.localeCompare(b.textContent));
        unpinned.forEach(option => listbox.append(option));
        this.options = Array.from(this.querySelectorAll('[name="country_code"]'));
        this.empty = this.querySelector('.kk-currency-empty');
        if (!this.search || !this.empty) return;
        this.normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
        this.search.addEventListener('input', () => this.filter(), { signal });
        this.addEventListener('keydown', event => this.navigate(event), { signal, capture: true });
        this.closest('x-popover')?.addEventListener('dialog:after-hide', () => {
          this.search.value = '';
          this.filter();
        }, { signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      filter() {
        const terms = this.normalize(this.search.value).split(/\s+/).filter(Boolean);
        this.toggleAttribute('data-filtering', terms.length > 0);
        let matches = 0;
        this.options.forEach(option => {
          const text = this.normalize(option.dataset.search || option.textContent);
          option.hidden = !terms.every(term => text.includes(term));
          if (!option.hidden) matches += 1;
        });
        this.empty.hidden = matches > 0;
      }

      navigate(event) {
        const inSearch = event.target === this.search;
        if (inSearch && event.key === 'Enter') {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        const arrow = event.key === 'ArrowDown' || event.key === 'ArrowUp';
        const boundary = !inSearch && (event.key === 'Home' || event.key === 'End');
        if (!arrow && !boundary) return;
        if (!inSearch && !event.target.matches('[name="country_code"]')) return;
        event.preventDefault();
        event.stopPropagation();
        const visible = this.options.filter(option => !option.hidden);
        if (!visible.length) return;
        const current = visible.indexOf(event.target);
        let next;
        if (event.key === 'Home') next = visible[0];
        else if (event.key === 'End') next = visible[visible.length - 1];
        else if (inSearch) next = event.key === 'ArrowDown' ? visible[0] : visible[visible.length - 1];
        else if (event.key === 'ArrowUp') next = current > 0 ? visible[current - 1] : this.search;
        else next = visible[Math.min(current + 1, visible.length - 1)];
        next?.focus();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
